// import { useState, useEffect, useRef } from "react";
// import { useLocation, Link, useNavigate } from "react-router-dom";
// import PropTypes from "prop-types";
// import IdleTracker from "components/IdleTracker";
// import ActivityTracker from "components/ActivityTracker";

// // MUI
// import IconButton from "@mui/material/IconButton";
// import AppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import Menu from "@mui/material/Menu";
// import Icon from "@mui/material/Icon";
// import axios from "axios";
// import Modal from "@mui/material/Modal";
// import Button from "@mui/material/Button";
// import TextField from "@mui/material/TextField";


// // Core / theme helpers
// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";
// import Breadcrumbs from "examples/Breadcrumbs";
// import NotificationItem from "examples/Items/NotificationItem";
// import { API_URL } from "config";

// import {
//   navbar,
//   navbarContainer,
//   navbarRow,
//   navbarIconButton,
//   navbarDesktopMenu,
//   navbarMobileMenu,
// } from "examples/Navbars/DashboardNavbar/styles";

// import {
//   useSoftUIController,
//   setTransparentNavbar,
//   setMiniSidenav,
//   setOpenConfigurator,
// } from "context";

// // Media
// import team2 from "assets/images/team-2.jpg";
// import logoSpotify from "assets/images/small-logos/logo-spotify.svg";

// // Auth + Break handling
// import { useAuth } from "AuthContext";
// //import useBreakManager from "context/BreakContext";
// import BreakModal from "layouts/break/BreakModal";

// function DashboardNavbar({ absolute = false, light = false, isMini = false }) {
//   const [loginStatus, setLoginStatus] = useState(null);
//   const [loginModalOpen, setLoginModalOpen] = useState(false);
//   const [loginComment, setLoginComment] = useState("");
//   // ⏱️ Early / Late live timer (OLD UX)
//   const [displayMinutes, setDisplayMinutes] = useState(0);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [actionText, setActionText] = useState("");

//   const [navbarType, setNavbarType] = useState();
//   const [openMenu, setOpenMenu] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [logoutLoading, setLogoutLoading] = useState(false);
//   const [userName, setUserName] = useState("");
//   const [locationBlocked, setLocationBlocked] = useState(false);
//   const [checkingLocation, setCheckingLocation] = useState(false);
//   const locationPollRef = useRef(null);
//   const permissionStatusRef = useRef(null);

//   const [controller, dispatch] = useSoftUIController();
//   const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } = controller;

//   const { isLoggedIn, logout: authLogout } = useAuth();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const route = location.pathname.split("/").slice(1);
//   const [onBreak, setOnBreak] = useState(false);
//   const [timer, setTimer] = useState(0); // seconds
//   const [activityCounts, setActivityCounts] = useState({});

//   // ⏳ Pending approval polling (USER only)
//   const pendingPollingRef = useRef(null);


//   useEffect(() => {
//     const name = localStorage.getItem("name");
//     if (name) setUserName(name);
//   }, []);

//   useEffect(() => {
//     if (!isLoggedIn || !navigator.permissions) return;

//     const startOneShotCheck = () => {
//       // 1 second safety check (single-shot style)
//       if (locationPollRef.current) return;

//       locationPollRef.current = setTimeout(async () => {
//         try {
//           const p = await navigator.permissions.query({ name: "geolocation" });
//           if (p.state === "granted") {
//             setLocationBlocked(false);
//           }
//         } catch { }
//         // 🛑 always stop after one shot
//         if (locationPollRef.current) {
//           clearTimeout(locationPollRef.current);
//           locationPollRef.current = null;
//         }
//       }, 1000);
//     };

//     const stopAnyTimer = () => {
//       if (locationPollRef.current) {
//         clearTimeout(locationPollRef.current);
//         locationPollRef.current = null;
//       }
//     };

//     const applyState = (state) => {
//       if (state === "denied") {
//         // ❌ Blocked → turant modal open
//         setLocationBlocked(true);

//         // ⏱️ start 1-sec safety check
//         startOneShotCheck();

//         // 🛑 modal open hote hi, hum continuous polling nahi rakhte
//         // (timer khud 1 shot me clear ho jayega)
//       } else if (state === "granted") {
//         // ✅ Allowed → modal close, no polling
//         setLocationBlocked(false);
//         stopAnyTimer();
//       } else {
//         // "prompt" → strict mode: treat as blocked
//         setLocationBlocked(true);
//         startOneShotCheck();
//       }
//     };

//     const setup = async () => {
//       try {
//         const status = await navigator.permissions.query({ name: "geolocation" });
//         permissionStatusRef.current = status;

//         // initial sync
//         applyState(status.state);

//         // 🔔 instant reaction (same tab / other tab)
//         status.onchange = () => {
//           applyState(status.state);
//         };
//       } catch (e) {
//         console.warn("Permissions API not available", e);
//       }
//     };

//     setup();

//     return () => {
//       if (permissionStatusRef.current) {
//         permissionStatusRef.current.onchange = null;
//       }
//       stopAnyTimer();
//     };
//   }, [isLoggedIn]);



//   useEffect(() => {
//     setNavbarType(fixedNavbar ? "sticky" : "static");
//     const handleTransparentNavbar = () => {
//       setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
//     };
//     window.addEventListener("scroll", handleTransparentNavbar);
//     handleTransparentNavbar();
//     return () => window.removeEventListener("scroll", handleTransparentNavbar);
//   }, [dispatch, fixedNavbar]);

//   const getElapsedSecondsFromBackend = (breakStartedAt) => {
//     if (!breakStartedAt) return 0;

//     const start = new Date(breakStartedAt).getTime();
//     const now = Date.now();

//     return Math.max(Math.floor((now - start) / 1000), 0);
//   };

//   // =====================================================
//   // 🔁 PENDING APPROVAL POLLING (30 sec)
//   // =====================================================

//   const startPendingPolling = () => {
//     if (pendingPollingRef.current) return; // already running

//     pendingPollingRef.current = setInterval(async () => {
//       try {
//         const token = localStorage.getItem("authToken");
//         if (!token) return;

//         const { data } = await axios.get(
//           `${API_URL}/attendance/status`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         // 🔥 APPLY BACKEND TRUTH
//         setLoginStatus(data);

//         setTimeout(() => {
//           fetchActivityWatchAFK();
//         }, 500);

//         // 🔥 ROUTE VISIBILITY (SESSION AWARE)
//         if (data?.permissions) {
//           localStorage.setItem(
//             "route_visibility",
//             JSON.stringify(data.permissions)
//           );
//         }

//         setLoginModalOpen(Boolean(data?.show_popup));

//         // if (data?.onBreak && data?.break_started_at) {
//         //   setTimer(getElapsedSecondsFromBackend(data.break_started_at));
//         // } else {
//         //   setTimer(0);
//         // }

//       } catch (err) {
//         console.error("Pending approval polling failed", err);
//       }
//     }, 60000); // ⏱️ 60 seconds
//   };

//   const stopPendingPolling = () => {
//     if (pendingPollingRef.current) {
//       clearInterval(pendingPollingRef.current);
//       pendingPollingRef.current = null;
//     }
//   };


//   useEffect(() => {

//     const fetchLoginStatus = async () => {
//       try {
//         const token = localStorage.getItem("authToken");
//         if (!token) return;

//         const { data } = await axios.get(
//           `${API_URL}/attendance/status`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         setLoginStatus(data);

//         // 🔥 ACTIVITYWATCH CHECK
//         setTimeout(() => {
//           fetchActivityWatchAFK();
//         }, 500);

//         // 🔥 ROUTE VISIBILITY (SESSION AWARE)
//         if (data?.permissions) {
//           localStorage.setItem(
//             "route_visibility",
//             JSON.stringify(data.permissions)
//           );
//         }

//         setOnBreak(Boolean(data?.onBreak));

//         if (data?.onBreak && data?.break_started_at) {
//           setTimer(getElapsedSecondsFromBackend(data.break_started_at));
//         } else {
//           setTimer(0);
//         }


//         // 🟢 POPUP — STRICTLY backend driven
//         setLoginModalOpen(Boolean(data?.show_popup));


//       } catch (err) {
//         console.error("checkLoginStatus failed", err);
//       }
//     };


//     fetchLoginStatus();


//   }, [isLoggedIn]);

//   // useEffect(() => {
//   //   if (!isLoggedIn) return;

//   //   const check = async () => {
//   //     try {
//   //       await getLocation();
//   //       setLocationBlocked(false);
//   //     } catch {
//   //       setLocationBlocked(true);
//   //     }
//   //   };

//   //   check();
//   // }, [isLoggedIn, loginStatus]);



//   useEffect(() => {
//     if (!loginStatus) return;

//     // ✅ ONLY popup based early / late
//     // ✅ BACKEND is single source of truth for minutes
//     if (
//       loginStatus.session === null &&
//       (loginStatus.status === "early_login" || loginStatus.status === "late_login")
//     ) {
//       const baseMinutes =
//         loginStatus.status === "late_login"
//           ? Number(loginStatus.late_minutes ?? 0)
//           : Number(loginStatus.early_minutes ?? 0);

//       setDisplayMinutes(baseMinutes);

//       const timer = setInterval(() => {
//         setDisplayMinutes((prev) =>
//           loginStatus.status === "late_login" ? prev + 1 : prev - 1
//         );
//       }, 60000);

//       return () => clearInterval(timer);
//     }

//     // ✅ reset when popup not required
//     setDisplayMinutes(0);

//   }, [loginStatus]);

//   useEffect(() => {
//     if (!loginStatus) return;

//     handleAutoLogout();

//   }, [loginStatus]);

//   // =====================================================
//   // 🎯 START / STOP POLLING BASED ON STATUS
//   // =====================================================
//   useEffect(() => {
//     if (!loginStatus) return;

//     const isPendingApproval =
//       loginStatus.session === null &&
//       (
//         loginStatus.status === "pending_early_login" ||
//         loginStatus.status === "pending_late_login"
//       );

//     if (isPendingApproval) {
//       // ✅ START polling
//       startPendingPolling();
//     } else {
//       // 🛑 STOP polling
//       stopPendingPolling();
//     }

//     // cleanup on unmount
//     return () => {
//       stopPendingPolling();
//     };
//   }, [loginStatus]);



//   // ========================================
//   // ⏭️ NEXT STATUS AUTO RECHECK (TOO EARLY)
//   // ========================================
//   useEffect(() => {
//     if (!loginStatus) return;

//     // 🧹 cleanup old timer
//     if (nextStatusCheckTimerRef.current) {
//       clearTimeout(nextStatusCheckTimerRef.current);
//       nextStatusCheckTimerRef.current = null;
//     }

//     // ✅ ONLY when backend explicitly asks
//     if (
//       (loginStatus.session === null || loginStatus.session === "attendance") &&
//       (loginStatus.status === "work_finished" || loginStatus.status === "early_login" || loginStatus.status === "on_time" || loginStatus.status === "already_logged_in") &&
//       Number(loginStatus.next_status_check_seconds) > 0
//     ) {
//       const seconds = Number(loginStatus.next_status_check_seconds);

//       nextStatusCheckTimerRef.current = setTimeout(async () => {
//         try {
//           const token = localStorage.getItem("authToken");
//           if (!token) return;

//           const { data } = await axios.get(
//             `${API_URL}/attendance/status`,
//             { headers: { Authorization: `Bearer ${token}` } }
//           );

//           // 🔥 APPLY BACKEND TRUTH
//           setLoginStatus(data);

//           setTimeout(() => {
//             fetchActivityWatchAFK();
//           }, 500);

//           // 🔥 ROUTE VISIBILITY (SESSION AWARE)
//           if (data?.permissions) {
//             localStorage.setItem(
//               "route_visibility",
//               JSON.stringify(data.permissions)
//             );
//           }

//           setLoginModalOpen(Boolean(data?.show_popup));

//           // if (data?.onBreak && data?.break_started_at) {
//           //   setTimer(getElapsedSecondsFromBackend(data.break_started_at));
//           // } else {
//           //   setTimer(0);
//           // }

//         } catch (err) {
//           console.error("Next status auto recheck failed", err);
//         }
//       }, seconds * 1000);
//     }

//     // cleanup on change / unmount
//     return () => {
//       if (nextStatusCheckTimerRef.current) {
//         clearTimeout(nextStatusCheckTimerRef.current);
//         nextStatusCheckTimerRef.current = null;
//       }
//     };

//   }, [loginStatus]);


//   // ========================================
//   // ⏱️ BREAK TIMER (1 sec → continuous)
//   // ========================================
//   useEffect(() => {
//     let interval = null;

//     if (onBreak) {
//       interval = setInterval(() => {
//         setTimer((prev) => prev + 1); // 1 sec increment
//       }, 1000);
//     }

//     return () => {
//       if (interval) clearInterval(interval);
//     };
//   }, [onBreak]);


//   const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
//   const handleConfigurator = () => setOpenConfigurator(dispatch, !openConfigurator);
//   const handleOpenMenu = (e) => setOpenMenu(e.currentTarget);
//   const handleCloseMenu = () => setOpenMenu(false);

//   // const handleStartBreak = async () => {
//   //   setLoading(true);
//   //   try {
//   //     const token = localStorage.getItem("authToken");

//   //     if (loginStatus?.session === "attendance") {
//   //       await axios.post(
//   //         `${API_URL}/attendance/break/start`,
//   //         {},
//   //         { headers: { Authorization: `Bearer ${token}` } }
//   //       );
//   //     }

//   //     if (loginStatus?.session === "overtime") {
//   //       await axios.post(
//   //         `${API_URL}/overtime/break/start`,
//   //         {},
//   //         { headers: { Authorization: `Bearer ${token}` } }
//   //       );
//   //     }

//   //     // 🔄 ALWAYS refresh truth
//   //     const { data } = await axios.get(
//   //       `${API_URL}/attendance/status`,
//   //       { headers: { Authorization: `Bearer ${token}` } }
//   //     );

//   //     setLoginStatus(data);

//   //     // 🔥 ROUTE VISIBILITY (SESSION AWARE)
//   //     if (data?.permissions) {
//   //       localStorage.setItem(
//   //         "route_visibility",
//   //         JSON.stringify(data.permissions)
//   //       );
//   //     }

//   //     setOnBreak(Boolean(data.onBreak));

//   //     if (data?.onBreak && data?.break_started_at) {
//   //       setTimer(getElapsedSecondsFromBackend(data.break_started_at));
//   //     } else {
//   //       setTimer(0);
//   //     }


//   //   } catch (err) {
//   //     console.error("Break start failed", err);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };


//   const handleStartBreak = async () => {
//     setLoading(true);
//     try {
//       const token = localStorage.getItem("authToken");
//       const endpoint =
//         loginStatus?.session === "overtime" ? "overtime" : "attendance";

//       await axios.post(
//         `${API_URL}/${endpoint}/break/start`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       // ✅ 1. INSTANT UI FEEDBACK
//       setOnBreak(true);
//       setTimer(0);

//       // ✅ 2. BACKEND TRUTH
//       const { data } = await axios.get(
//         `${API_URL}/attendance/status`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       setLoginStatus(data);

//       // ✅ 3. DEFENSIVE SYNC
//       if (data?.onBreak === false) {
//         setOnBreak(false);
//         setTimer(0);
//       }

//     } catch (err) {
//       console.error("Break start failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };



//   const handleEndBreak = async () => {
//     try {
//       const token = localStorage.getItem("authToken");

//       if (loginStatus?.session === "attendance") {
//         await axios.post(
//           `${API_URL}/attendance/break/end`,
//           {},
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       }

//       if (loginStatus?.session === "overtime") {
//         await axios.post(
//           `${API_URL}/overtime/break/end`,
//           {},
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       }

//       const { data } = await axios.get(
//         `${API_URL}/attendance/status`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       setLoginStatus(data);

//       // 🔥 ROUTE VISIBILITY (SESSION AWARE)
//       if (data?.permissions) {
//         localStorage.setItem(
//           "route_visibility",
//           JSON.stringify(data.permissions)
//         );
//       }

//       setOnBreak(Boolean(data.onBreak));
//       setTimer(0);

//     } catch (err) {
//       console.error("Failed to end break", err);
//     }
//   };


//   const autoLogoutTimerRef = useRef(null);
//   const nextStatusCheckTimerRef = useRef(null);
//   const afkBucketRef = useRef(null);

//   // const getAFKBucket = async () => {
//   //   try {

//   //     // 🔹 already detected → reuse
//   //     if (afkBucketRef.current) {
//   //       return afkBucketRef.current;
//   //     }

//   //     const res = await fetch("http://localhost:5600/api/0/buckets");

//   //     if (!res.ok) return null;

//   //     const buckets = await res.json();

//   //     const bucketId = Object.keys(buckets).find((b) =>
//   //       b.startsWith("aw-watcher-afk")
//   //     );

//   //     if (bucketId) {
//   //       afkBucketRef.current = bucketId;
//   //     }

//   //     return bucketId || null;

//   //   } catch {
//   //     return null;
//   //   }
//   // };

//   // =====================================================
//   // 🔥 ACTIVITYWATCH AFK FETCH
//   // =====================================================
//   // const fetchActivityWatchAFK = async () => {
//   //   try {

//   //     // ❌ guard rules
//   //     if (!loginStatus) return;
//   //     if (loginStatus.status !== "already_logged_in") return;
//   //     if (loginStatus.onBreak === true) return;

//   //     // const res = await fetch("http://localhost:5600/api/0/buckets/aw-watcher-afk/events");

//   //     const bucketId = await getAFKBucket();

//   //     if (!bucketId) return;

//   //     // const res = await fetch(
//   //     //   `http://localhost:5600/api/0/buckets/${bucketId}/events`
//   //     // );

//   //     const now = new Date();

//   //     const startOfDay = new Date();
//   //     startOfDay.setHours(0, 0, 0, 0);

//   //     const res = await fetch(
//   //       `http://localhost:5600/api/0/buckets/${bucketId}/events?start=${startOfDay.toISOString()}&end=${now.toISOString()}`
//   //     );

//   //     if (!res.ok) return;

//   //     const events = await res.json();

//   //     if (!Array.isArray(events)) return;

//   //     // 🔎 filter afk + duration >= 60
//   //     const filtered = events.filter(
//   //       (e) =>
//   //         e?.data?.status === "afk" &&
//   //         Number(e?.duration) >= 60
//   //     );

//   //     if (filtered.length === 0) return;

//   //     const payload = filtered.map((e) => ({
//   //       source_event_id: e.id,
//   //       timestamp: e.timestamp,
//   //       duration_sec: Math.floor(e.duration),
//   //     }));

//   //     const token = localStorage.getItem("authToken");

//   //     await axios.post(
//   //       `${API_URL}/activitywatch/idle-logs`,
//   //       {
//   //         session: loginStatus?.session,
//   //         logs: payload,
//   //       },
//   //       {
//   //         headers: { Authorization: `Bearer ${token}` },
//   //       }
//   //     );

//   //   } catch (err) {
//   //     console.warn("ActivityWatch fetch failed", err);
//   //   }
//   // };

//   const getAFKBucket = async () => {
//     console.log('🔍 getAFKBucket() called');
//     try {
//       if (afkBucketRef.current) {
//         console.log('✅ Using cached bucket:', afkBucketRef.current);
//         return afkBucketRef.current;
//       }

//       console.log('🌐 Fetching buckets from ActivityWatch...');
//       //const res = await fetch("http://localhost:5600/api/0/buckets");

//       if (!res.ok) {
//         console.log('❌ Bucket fetch failed:', res.status, res.statusText);
//         return null;
//       }

//       const buckets = await res.json();
//       console.log('📦 Available buckets:', Object.keys(buckets));

//       const bucketId = Object.keys(buckets).find((b) =>
//         b.startsWith("aw-watcher-afk")
//       );

//       if (bucketId) {
//         console.log('✅ Found AFK bucket:', bucketId);
//         afkBucketRef.current = bucketId;
//       } else {
//         console.log('❌ No AFK bucket found in buckets');
//       }

//       return bucketId || null;

//     } catch (err) {
//       console.warn('❌ Error in getAFKBucket:', err);
//       return null;
//     }
//   };

//   const fetchActivityWatchAFK = async () => {
//     console.log('🚀 fetchActivityWatchAFK() started');

//     try {
//       // ❌ guard rules
//       if (!loginStatus) {
//         console.log('❌ loginStatus is null, returning');
//         return;
//       }
//       if (loginStatus.status !== "already_logged_in") {
//         console.log('❌ status not already_logged_in:', loginStatus.status);
//         return;
//       }
//       if (loginStatus.onBreak === true) {
//         console.log('❌ user is on break, returning');
//         return;
//       }

//       console.log('✅ Guard checks passed, fetching bucket...');
//       const bucketId = await getAFKBucket();
//       console.log('📦 bucketId:', bucketId);

//       if (!bucketId) {
//         console.log('❌ No AFK bucket found, returning');
//         return;
//       }

//       const now = new Date();
//       const startOfDay = new Date();
//       startOfDay.setHours(0, 0, 0, 0);

//       // const url = `http://localhost:5600/api/0/buckets/${bucketId}/events?start=${startOfDay.toISOString()}&end=${now.toISOString()}`;
//       console.log('🌐 Fetching from ActivityWatch:', url);

//       const res = await fetch(url);

//       if (!res.ok) {
//         console.log('❌ ActivityWatch response not OK:', res.status, res.statusText);
//         return;
//       }

//       const events = await res.json();
//       console.log(`📊 Received ${events.length} events from ActivityWatch`);

//       if (!Array.isArray(events)) {
//         console.log('❌ Events is not an array');
//         return;
//       }

//       // 🔎 filter afk + duration >= 60
//       const filtered = events.filter(
//         (e) =>
//           e?.data?.status === "afk" &&
//           Number(e?.duration) >= 60
//       );

//       console.log(`🔍 Filtered ${filtered.length} AFK events with duration >= 60`);

//       if (filtered.length === 0) {
//         console.log('⏸️ No matching events, returning');
//         return;
//       }

//       const payload = filtered.map((e) => ({
//         source_event_id: e.id,
//         timestamp: e.timestamp,
//         duration_sec: Math.floor(e.duration),
//       }));

//       console.log('📦 Payload prepared:', payload);

//       const token = localStorage.getItem("authToken");
//       if (!token) {
//         console.log('❌ No auth token, returning');
//         return;
//       }

//       console.log('📤 Sending to backend:', `${API_URL}/activitywatch/idle-logs`);
//       const response = await axios.post(
//         `${API_URL}/activitywatch/idle-logs`,
//         {
//           session: loginStatus?.session,
//           logs: payload,
//         },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       console.log('✅ Backend response:', response.data);

//     } catch (err) {
//       console.warn('❌ ActivityWatch fetch failed:', err);
//     }
//   };


//   useEffect(() => {
//     return () => {
//       if (autoLogoutTimerRef.current) {
//         clearTimeout(autoLogoutTimerRef.current);
//         autoLogoutTimerRef.current = null;
//       }
//       // 🧹 stop pending approval polling
//       stopPendingPolling();
//     };
//   }, []);


//   const handleAutoLogout = () => {
//     // 🛑 cleanup old timer
//     if (autoLogoutTimerRef.current) {
//       clearTimeout(autoLogoutTimerRef.current);
//       autoLogoutTimerRef.current = null;
//     }

//     const seconds = Number(loginStatus?.auto_logout_after_seconds);

//     // ❌ no seconds → nothing to do
//     if (!seconds || seconds <= 0) {
//       return;
//     }

//     autoLogoutTimerRef.current = setTimeout(async () => {

//       // 🔥 FINAL AFK FETCH BEFORE AUTO LOGOUT
//       await fetchActivityWatchAFK();


//       try {
//         const token = localStorage.getItem("authToken");

//         // 🌍 get location (same as manual logout)
//         const coords = await getLocation();
//         // ================================
//         // 🔹 SEND ACTIVITY SUMMARY (BEFORE AUTO LOGOUT)
//         // ================================
//         try {
//           if (activityCounts && Object.keys(activityCounts).length > 0) {
//             await axios.post(
//               `${API_URL}/activity-summary`,
//               {
//                 session: loginStatus?.session, // "attendance" or "overtime"
//                 counts: activityCounts,
//               },
//               {
//                 headers: { Authorization: `Bearer ${token}` },
//               }
//             );
//           }
//         } catch (e) {
//           console.warn("Activity summary send failed (auto logout)", e);
//         }

//         // ======================================
//         // 🔥 BACKEND-AWARE AUTO LOGOUT
//         // ======================================
//         if (loginStatus?.session === "overtime") {
//           await axios.post(
//             `${API_URL}/overtime/logout`,
//             {
//               type: "auto",
//               latitude: coords.latitude,
//               longitude: coords.longitude,
//             },
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             }
//           );
//         }

//         if (loginStatus?.session === "attendance") {
//           await axios.post(
//             `${API_URL}/attendance/logout`,
//             {
//               type: "auto",
//               latitude: coords.latitude,
//               longitude: coords.longitude,
//             },
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             }
//           );
//         }

//         // ======================================
//         // 🔚 FRONTEND LOGOUT (ALWAYS)
//         // ======================================

//         setActivityCounts({});

//         // 🔚 FRONTEND LOGOUT
//         localStorage.removeItem("route_visibility");
//         await authLogout();
//         navigate("/authentication/sign-in/illustration", { replace: true });

//       } catch (err) {
//         // 🔚 FRONTEND LOGOUT
//         localStorage.removeItem("route_visibility");
//         // 🛑 Hard safety — never keep user logged in
//         await authLogout();
//         navigate("/authentication/sign-in/illustration", { replace: true });
//       }
//     }, seconds * 1000);
//   };



//   // =====================================================
//   // 🎯 EXACT BACKEND-DRIVEN HIDE RULES
//   // =====================================================

//   const showStartBreakButton =
//     loginStatus?.break_allowed === true &&
//     loginStatus?.onBreak === false &&
//     (loginStatus?.session === "attendance" ||
//       loginStatus?.session === "overtime");

//   const showLogoutButton = loginStatus?.manual_logout_allowed === true;


//   // const getLocation = () => {
//   //   return new Promise((resolve) => {
//   //     if (!navigator.geolocation) {
//   //       resolve({ latitude: null, longitude: null });
//   //       return;
//   //     }

//   //     navigator.geolocation.getCurrentPosition(
//   //       (pos) =>
//   //         resolve({
//   //           latitude: pos.coords.latitude,
//   //           longitude: pos.coords.longitude,
//   //         }),
//   //       () => resolve({ latitude: null, longitude: null })
//   //     );
//   //   });
//   // };


//   const getLocation = () => {
//     return new Promise((resolve, reject) => {
//       if (!navigator.geolocation) {
//         reject(new Error("Geolocation not supported"));
//         return;
//       }

//       navigator.geolocation.getCurrentPosition(
//         (pos) => {
//           resolve({
//             latitude: pos.coords.latitude,
//             longitude: pos.coords.longitude,
//           });
//         },
//         (err) => {
//           reject(err); // user denied / blocked
//         },
//         {
//           enableHighAccuracy: true,
//           timeout: 10000,
//           maximumAge: 0,
//         }
//       );
//     });
//   };


//   // MANUAL LOGOUT ORIGINAL RULE RESTORED
//   const handleLogout = async () => {
//     setLogoutLoading(true);

//     try {
//       const token = localStorage.getItem("authToken");
//       // const coords = await getLocation();

//       let coords;
//       try {
//         coords = await getLocation();
//       } catch (e) {
//         setLocationBlocked(true);
//         return;
//       }


//       // ============================================
//       // ❌ SAFETY: logout button dikha hi nahi
//       // ============================================
//       if (loginStatus?.manual_logout_allowed !== true) {
//         return;
//       }

//       // ============================================
//       // 🔥 API BASED LOGOUT (ATTENDANCE / OVERTIME)
//       // ============================================
//       if (loginStatus?.manual_logout_api === true) {

//         // 🔥 FINAL AFK FETCH BEFORE LOGOUT
//         await fetchActivityWatchAFK();

//         // ================================
//         // 🔹 SEND ACTIVITY SUMMARY (BEFORE LOGOUT)
//         // ================================
//         try {
//           if (activityCounts && Object.keys(activityCounts).length > 0) {
//             await axios.post(
//               `${API_URL}/activity-summary`,
//               {
//                 session: loginStatus.session, // "attendance" or "overtime"
//                 counts: activityCounts,
//               },
//               {
//                 headers: { Authorization: `Bearer ${token}` },
//               }
//             );
//           }
//         } catch (e) {
//           console.warn("Activity summary send failed (manual logout)", e);
//         }



//         // 🔹 ATTENDANCE LOGOUT
//         if (loginStatus.session === "attendance") {
//           await axios.post(
//             `${API_URL}/attendance/logout`,
//             {
//               type: "manual",
//               latitude: coords.latitude,
//               longitude: coords.longitude,
//               session: "attendance",
//             },
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             }
//           );
//         }

//         // 🔹 OVERTIME LOGOUT
//         if (loginStatus.session === "overtime") {
//           await axios.post(
//             `${API_URL}/overtime/logout`,
//             {
//               latitude: coords.latitude,
//               longitude: coords.longitude,
//               session: "overtime",
//               type: "manual",
//             },
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             }
//           );
//         }

//         setActivityCounts({});

//         // 🔚 FRONTEND LOGOUT
//         localStorage.removeItem("route_visibility");
//         // 🔚 FRONTEND LOGOUT
//         await authLogout();
//         navigate("/authentication/sign-in/illustration", { replace: true });
//         return;
//       }

//       // ============================================
//       // 🟡 FRONTEND-ONLY LOGOUT (NO API)
//       // ============================================
//       // 🔚 FRONTEND LOGOUT
//       localStorage.removeItem("route_visibility");
//       await authLogout();
//       navigate("/authentication/sign-in/illustration", { replace: true });

//     } catch (err) {
//       console.error("Logout failed", err);
//     } finally {
//       setLogoutLoading(false);
//     }
//   };


//   const renderMenu = () => (
//     <Menu
//       anchorEl={openMenu}
//       anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//       open={Boolean(openMenu)}
//       onClose={handleCloseMenu}
//       sx={{ mt: 2 }}
//     >
//       <NotificationItem
//         image={<img src={team2} alt="person" />}
//         title={["New message", "from Laur"]}
//         date="13 minutes ago"
//         onClick={handleCloseMenu}
//       />
//       <NotificationItem
//         image={<img src={logoSpotify} alt="logo" />}
//         title={["New album", "by Travis Scott"]}
//         date="1 day"
//         onClick={handleCloseMenu}
//       />
//       <NotificationItem
//         color="secondary"
//         image={<Icon fontSize="small">payment</Icon>}
//         title={["", "Payment successfully completed"]}
//         date="2 days"
//         onClick={handleCloseMenu}
//       />
//     </Menu>
//   );

//   return (
//     <AppBar position={absolute ? "absolute" : navbarType} color="inherit"
//       sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
//     >
//       <Toolbar sx={(theme) => navbarContainer(theme)}>
//         <SoftBox
//           color="inherit"
//           mb={{ xs: 1, md: 0 }}
//           sx={(theme) => navbarRow(theme, { isMini })}
//         >
//           {/* <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} /> */}
//           <Icon fontSize="medium" sx={navbarDesktopMenu} onClick={handleMiniSidenav}>
//             {miniSidenav ? "menu_open" : "menu"}
//           </Icon>
//         </SoftBox>

//         {!isMini && (
//           <SoftBox sx={(theme) => navbarRow(theme, { isMini })}>
//             <SoftBox color={light ? "white" : "inherit"}>
//               {isLoggedIn ? (
//                 <>
//                   {userName && (
//                     <SoftTypography variant="button" fontWeight="medium"
//                       color={light ? "white" : "dark"}
//                       sx={{ mr: 2, display: "inline-block" }}
//                     >
//                       Welcome - {userName}
//                     </SoftTypography>
//                   )}

//                   {showStartBreakButton && (

//                     <IconButton
//                       sx={{ ...navbarIconButton, mr: 1 }}
//                       size="small"
//                       onClick={handleStartBreak}
//                       disabled={loading}
//                     >
//                       <Icon sx={{ color: light ? "#fff" : "#1e293b" }}>
//                         {loading ? "hourglass_top" : "pause_circle"}
//                       </Icon>
//                       <SoftTypography
//                         variant="button"
//                         fontWeight="medium"
//                         color={light ? "white" : "dark"}
//                         ml={0.5}
//                       >
//                         {loading ? "Starting..." : "Start Break"}
//                       </SoftTypography>
//                     </IconButton>
//                   )}

//                   {showLogoutButton && (
//                     <IconButton
//                       sx={navbarIconButton}
//                       size="small"
//                       onClick={handleLogout}
//                       disabled={logoutLoading}
//                     >
//                       <Icon sx={{ color: light ? "#fff" : "#1e293b" }}>
//                         {logoutLoading ? "hourglass_top" : "logout"}
//                       </Icon>
//                       <SoftTypography variant="button" fontWeight="medium"
//                         color={light ? "white" : "dark"} ml={0.5}
//                       >
//                         {logoutLoading ? "Logging out..." : "Logout"}
//                       </SoftTypography>
//                     </IconButton>
//                   )}
//                 </>
//               ) : (
//                 <Link to="/authentication/sign-in/illustration">
//                   <IconButton sx={navbarIconButton} size="small">
//                     <Icon sx={{ color: light ? "#fff" : "#1e293b" }}>account_circle</Icon>
//                     <SoftTypography variant="button" fontWeight="medium"
//                       color={light ? "white" : "dark"} ml={0.5}
//                     >
//                       Sign in
//                     </SoftTypography>
//                   </IconButton>
//                 </Link>
//               )}

//               <IconButton size="small" color="inherit"
//                 sx={navbarMobileMenu} onClick={handleMiniSidenav}
//               >
//                 <Icon className={light ? "text-white" : "text-dark"}>
//                   {miniSidenav ? "menu_open" : "menu"}
//                 </Icon>
//               </IconButton>

//               <IconButton size="small" color="inherit"
//                 sx={navbarIconButton} onClick={handleConfigurator}
//               >
//                 <Icon>settings</Icon>
//               </IconButton>

//               <IconButton size="small" color="inherit"
//                 sx={navbarIconButton} onClick={handleOpenMenu}
//               >
//                 <Icon className={light ? "text-white" : "text-dark"}>notifications</Icon>
//               </IconButton>

//               {renderMenu()}
//             </SoftBox>
//           </SoftBox>
//         )}
//       </Toolbar>

//       {/* <Modal open={loginModalOpen} onClose={() => { }}> */}
//       <Modal open={loginModalOpen && !locationBlocked} onClose={() => { }}>
//         <SoftBox
//           style={{
//             background: "white",
//             padding: 30,
//             maxWidth: 400,
//             margin: "10% auto",
//             borderRadius: 10,
//             textAlign: "center",
//           }}
//         >
//           {loginStatus?.status?.startsWith("pending_") && (
//             <>
//               <SoftTypography variant="h6" mb={2}>
//                 Your login request has been sent
//               </SoftTypography>
//               <SoftTypography variant="body2" color="info">
//                 Please wait for approval from Team Leader / Manager / Admin.
//               </SoftTypography>
//             </>
//           )}

//           {loginStatus?.status === "on_time" && loginStatus?.session === "attendance" && (

//             <>
//               <SoftTypography variant="h6" mb={2}>
//                 Mark Attendance
//               </SoftTypography>
//               <Button
//                 variant="contained"
//                 color="success"
//                 fullWidth
//                 disabled={actionLoading}
//                 onClick={async () => {
//                   try {
//                     setActionLoading(true);
//                     setActionText("Marking Attendance...");

//                     const token = localStorage.getItem("authToken");
//                     // const coords = await getLocation();
//                     let coords;
//                     try {
//                       coords = await getLocation();
//                     } catch (e) {
//                       setLocationBlocked(true);
//                       return;
//                     }


//                     // ================================
//                     // 1️⃣ MARK ATTENDANCE (EXPLICIT)
//                     // ================================
//                     await axios.post(
//                       `${API_URL}/attendance/mark`,
//                       {
//                         action: "mark_attendance",
//                         latitude: coords.latitude,
//                         longitude: coords.longitude,
//                       },
//                       {
//                         headers: {
//                           Authorization: `Bearer ${token}`,
//                         },
//                       }
//                     );

//                     // ================================
//                     // 2️⃣ FETCH FRESH STATUS (MANDATORY)
//                     // ================================
//                     const { data } = await axios.get(
//                       `${API_URL}/attendance/status`,
//                       {
//                         headers: {
//                           Authorization: `Bearer ${token}`,
//                         },
//                       }
//                     );

//                     // ================================
//                     // 3️⃣ APPLY BACKEND TRUTH
//                     // ================================
//                     setLoginStatus(data);

//                     // 🔥 ROUTE VISIBILITY (SESSION AWARE)
//                     if (data?.permissions) {
//                       localStorage.setItem(
//                         "route_visibility",
//                         JSON.stringify(data.permissions)
//                       );
//                     }

//                     setLoginModalOpen(Boolean(data?.show_popup));

//                   } catch (err) {
//                     console.error("Attendance mark failed", err);
//                   } finally {
//                     setActionLoading(false);
//                     setActionText("");
//                   }
//                 }}
//               >
//                 {actionLoading ? actionText : "Mark Attendance"}
//               </Button>


//             </>
//           )}

//           {loginStatus?.status === "on_time" && loginStatus?.session === "overtime" && (
//             <>
//               <SoftTypography variant="h6" mb={2} color="info">
//                 Mark Overtime Attendance
//               </SoftTypography>

//               <Button
//                 variant="contained"
//                 color="info"
//                 fullWidth
//                 disabled={actionLoading}
//                 onClick={async () => {
//                   try {
//                     setActionLoading(true);
//                     setActionText("Marking Overtime Attendance...");
//                     //const coords = await getLocation();
//                     let coords;
//                     try {
//                       coords = await getLocation();
//                     } catch (e) {
//                       setLocationBlocked(true);
//                       return;
//                     }

//                     await axios.post(
//                       `${API_URL}/attendance/mark`,
//                       {
//                         action: "mark_overtime",
//                         latitude: coords.latitude,
//                         longitude: coords.longitude,
//                       },
//                       {
//                         headers: {
//                           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//                         },
//                       }
//                     );

//                     // 🔄 OT mark hone ke baad fresh status lao
//                     const { data } = await axios.get(
//                       `${API_URL}/attendance/status`,
//                       {
//                         headers: {
//                           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//                         },
//                       }
//                     );

//                     setLoginStatus(data);

//                     // 🔥 ROUTE VISIBILITY (SESSION AWARE)
//                     if (data?.permissions) {
//                       localStorage.setItem(
//                         "route_visibility",
//                         JSON.stringify(data.permissions)
//                       );
//                     }

//                     setLoginModalOpen(Boolean(data?.show_popup));

//                   } finally {
//                     setActionLoading(false);
//                     setActionText("");
//                   }
//                 }}
//               >
//                 {actionLoading ? actionText : "Mark Overtime Attendance"}
//               </Button>

//             </>
//           )}


//           {loginStatus?.status === "early_login" && loginStatus?.session === null && (
//             <>
//               <SoftTypography variant="h6" mb={1} color="warning">
//                 {"You are early!"}
//               </SoftTypography>

//               <SoftTypography variant="body2" mb={2}>
//                 You are <strong>{Number(displayMinutes).toFixed(2)}</strong> minutes early
//               </SoftTypography>

//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label="Reason"
//                 value={loginComment}
//                 onChange={(e) => setLoginComment(e.target.value)}
//                 sx={{ mb: 2 }}
//               />
//               <Button
//                 variant="contained"
//                 disabled={actionLoading}
//                 onClick={async () => {
//                   try {
//                     setActionLoading(true);
//                     setActionText("Sending Early Request...");

//                     const token = localStorage.getItem("authToken");

//                     // ✅ STEP-1: EARLY LOGIN REQUEST (JUST LIKE LATE)
//                     await axios.post(
//                       `${API_URL}/attendance/request-earlylogin`,
//                       {
//                         type: "early_login",
//                         comment: loginComment,
//                         minutes: Math.round(Number(loginStatus.early_minutes ?? 0)),
//                       },
//                       {
//                         headers: {
//                           Authorization: `Bearer ${token}`,
//                         },
//                       }
//                     );

//                     // ✅ STEP-2: ALWAYS FETCH FRESH STATUS
//                     const { data } = await axios.get(
//                       `${API_URL}/attendance/status`,
//                       {
//                         headers: {
//                           Authorization: `Bearer ${token}`,
//                         },
//                       }
//                     );

//                     // ✅ STEP-3: APPLY BACKEND TRUTH
//                     setLoginStatus(data);

//                     // 🔥 ROUTE VISIBILITY (SESSION AWARE)
//                     if (data?.permissions) {
//                       localStorage.setItem(
//                         "route_visibility",
//                         JSON.stringify(data.permissions)
//                       );
//                     }

//                     setLoginModalOpen(Boolean(data?.show_popup));

//                   } finally {
//                     setActionLoading(false);
//                     setActionText("");
//                   }
//                 }}
//               >
//                 {actionLoading ? actionText : "Request Early Approval"}
//               </Button>


//             </>
//           )}

//           {loginStatus?.status === "late_login" && loginStatus?.session === null && (
//             <>
//               <SoftTypography variant="h6" mb={1} color="error">
//                 {"You are late!"}
//               </SoftTypography>

//               <SoftTypography variant="body2" mb={2}>
//                 You are <strong>{Number(displayMinutes).toFixed(2)}</strong> minutes late
//               </SoftTypography>

//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label="Reason"
//                 value={loginComment}
//                 onChange={(e) => setLoginComment(e.target.value)}
//                 sx={{ mb: 2 }}
//               />
//               <Button
//                 variant="contained"
//                 color="warning"
//                 disabled={actionLoading}
//                 onClick={async () => {
//                   try {
//                     setActionLoading(true);
//                     setActionText("Sending Late Request...");

//                     await axios.post(
//                       `${API_URL}/attendance/request-late`,
//                       {
//                         type: "late_login",
//                         comment: loginComment,
//                         minutes: Math.round(Number(loginStatus.late_minutes ?? 0)),
//                       },
//                       {
//                         headers: {
//                           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//                         },
//                       }
//                     );

//                     // 🔥 STEP-2: TURANT STATUS LO (JAISA BREAK ME KARTE HO)
//                     const { data } = await axios.get(
//                       `${API_URL}/attendance/status`,
//                       {
//                         headers: {
//                           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//                         },
//                       }
//                     );

//                     // 🔥 STEP-3: BACKEND TRUTH APPLY
//                     setLoginStatus(data);

//                     // 🔥 ROUTE VISIBILITY (SESSION AWARE)
//                     if (data?.permissions) {
//                       localStorage.setItem(
//                         "route_visibility",
//                         JSON.stringify(data.permissions)
//                       );
//                     }

//                     setLoginModalOpen(Boolean(data?.show_popup));

//                   } finally {
//                     setActionLoading(false);
//                     setActionText("");
//                   }
//                 }}
//               >
//                 {actionLoading ? actionText : "Request Late Approval"}
//               </Button>

//             </>
//           )}

//         </SoftBox>
//       </Modal>

//       <Modal open={locationBlocked} onClose={() => { }}>
//         <SoftBox
//           style={{
//             background: "white",
//             padding: 30,
//             maxWidth: 420,
//             margin: "10% auto",
//             borderRadius: 10,
//             textAlign: "center",
//           }}
//         >
//           <SoftTypography variant="h6" mb={2} color="error">
//             Location Permission Required
//           </SoftTypography>

//           <SoftTypography variant="body2" mb={2}>
//             Location permission is mandatory to mark attendance.
//             Please click on the 🔒 icon in your browser’s address bar and set Location to “Allow”.
//           </SoftTypography>

//           <Button
//             variant="contained"
//             color="primary"
//             disabled={checkingLocation}
//             onClick={async () => {
//               try {
//                 setCheckingLocation(true);
//                 await getLocation();      // retry
//                 setLocationBlocked(false); // ✅ allowed → modal close
//               } catch (e) {
//                 setLocationBlocked(true);  // ❌ still blocked → keep open
//               } finally {
//                 setCheckingLocation(false);
//               }
//             }}
//           >
//             {checkingLocation ? "Checking..." : "I have enabled location"}
//           </Button>
//         </SoftBox>
//       </Modal>


//       <BreakModal
//         open={loginStatus?.onBreak === true}
//         timer={timer}
//         onEndBreak={handleEndBreak}
//       />

//       {/* {isLoggedIn && (
//         <IdleTracker onBreak={onBreak} />
//       )} */}

//       {isLoggedIn && (
//         <>
//           <IdleTracker onBreak={onBreak} session={loginStatus?.session} loginStatus={loginStatus?.status} />
//           <ActivityTracker
//             session={loginStatus?.session}
//             loginStatus={loginStatus?.status}
//             onCountsChange={setActivityCounts}
//           />
//         </>
//       )}




//     </AppBar>
//   );
// }


// DashboardNavbar.propTypes = {
//   absolute: PropTypes.bool,
//   light: PropTypes.bool,
//   isMini: PropTypes.bool,
// };

// export default DashboardNavbar;





import { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import ActivityTracker from "components/ActivityTracker";
// MUI
import IconButton from "@mui/material/IconButton";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import axios from "axios";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
// Core / theme helpers
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";
import { API_URL } from "config";

import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarDesktopMenu,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

import {
  useSoftUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";
// Media
// import team2 from "assets/images/team-2.jpg";
// import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
// Auth + Break handling
import { useAuth } from "AuthContext";
import BreakModal from "layouts/break/BreakModal";
import ProjectLiveChatInboxMenu from "layouts/project-live-chat/ProjectLiveChatInboxMenu";
import { useOutlookMail } from "layouts/outlook-mail/OutlookMailProvider";
import { formatMailTime } from "layouts/outlook-mail/api";
// Real-time Notifications
import getEcho from "echo";
import Swal from "sweetalert2";



function DashboardNavbar({ absolute = false, light = false, isMini = false }) {
  const activeChannelsRef = useRef(new Set());
  const [loginStatus, setLoginStatus] = useState(null);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [loginComment, setLoginComment] = useState("");
  // Attendance gap handling
  const [gapModalOpen, setGapModalOpen] = useState(false);
  const [gapReason, setGapReason] = useState("");
  const [gapMessage, setGapMessage] = useState("");
  const [gapMissingDays, setGapMissingDays] = useState(null);
  const [gapError, setGapError] = useState("");
  // ⏱️ Early / Late live timer (OLD UX)
  const [displayMinutes, setDisplayMinutes] = useState(0);
  const [actionLoading, setActionLoading] = useState(false);
  const [actionText, setActionText] = useState("");

  const [navbarType, setNavbarType] = useState();
  const [openMenu, setOpenMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [locationBlocked, setLocationBlocked] = useState(false);
  const [checkingLocation, setCheckingLocation] = useState(false);
  const locationPollRef = useRef(null);
  const permissionStatusRef = useRef(null);
  const { user, permissions: currentPermissions = [] } = useAuth();
  const outlookMail = useOutlookMail();
  const notificationScope = currentPermissions.slice().sort().join("|") + ":" + (outlookMail?.mailboxes || []).map((mailbox) => mailbox.key).sort().join(",") + ":" + Boolean(outlookMail?.permissions.notifications);
  const notificationsRequestRef = useRef(null);
  const notificationEpochRef = useRef(0);
  const notificationActorRef = useRef("");
  const currentNotificationActor = `${user?.actor_type || "user"}:${user?.id}:${notificationScope}`;
  notificationActorRef.current = currentNotificationActor;
  const isOutlookNotificationAllowed = (item) => item?.module !== "outlook_mail" && item?.meta?.module !== "outlook_mail" || Boolean(outlookMail?.canView && outlookMail?.grants.notifications && outlookMail?.permissions.notifications && outlookMail?.mailboxes.some((mailbox) => mailbox.key === item?.meta?.mailbox_key));
  const userId = user?.id;
  const actorType = user?.actor_type || "user";
  const isExternalVendorContact = actorType === "vendor_contact" && user?.vendor_type === "external";

  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } = controller;

  const { isLoggedIn, logout: authLogout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const route = location.pathname.split("/").slice(1);
  const [onBreak, setOnBreak] = useState(false);
  const [timer, setTimer] = useState(0); // seconds
  const [activityCounts, setActivityCounts] = useState({});
  // const [toasts, setToasts] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  // ⏳ Pending approval polling (USER only)
  const pendingPollingRef = useRef(null);

  const fetchStoredNotifications = useCallback(async () => {
    if (!isLoggedIn || !userId) return;

    try {
      const token = localStorage.getItem("authToken");
      notificationsRequestRef.current?.abort();
      const controller = new AbortController();
      notificationsRequestRef.current = controller;
      const epoch = notificationEpochRef.current;
      const scope = notificationActorRef.current;
      const { data } = await axios.get(`${API_URL}/notifications?unread=1&limit=50`, {
        headers: { Authorization: `Bearer ${token}` }, signal: controller.signal,
      });
      if (controller.signal.aborted || epoch !== notificationEpochRef.current || scope !== notificationActorRef.current) return;
      const rows = Array.isArray(data?.notifications) ? data.notifications.filter(isOutlookNotificationAllowed) : [];

      setUnreadCount(Number(data?.unread_count || 0));
      setNotifications(
        rows.map((item) => ({
          id: item.id,
          message: item.message,
          msg_time: item.msg_time,
          url: item.url,
          read: item.read,
          meta: item.meta || {},
          module: item.module,
          bid_tab: item.bid_tab,
        }))
      );
    } catch (error) {
      if (error?.name !== "CanceledError" && error?.name !== "AbortError") console.warn("Stored notifications could not be refreshed.");
    }
  }, [isLoggedIn, userId, actorType, notificationScope]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!isLoggedIn || !userId) return undefined;

    notificationEpochRef.current += 1;
    setNotifications([]);
    setUnreadCount(0);
    fetchStoredNotifications();

    const syncCountsHandler = (event) => {
      const payload = event.detail || {};
      const counts = payload.counts || payload;

      if (typeof counts?.total !== "undefined") {
        setUnreadCount(Number(counts.total || 0));
      }

      if (Array.isArray(payload.ids) && payload.ids.length) {
        const readIds = payload.ids.map(String);
        setNotifications((prev) => prev.filter((item) => !readIds.includes(String(item.id))));
      }

      if (payload.module && payload.bid_tab) {
        const tab = String(payload.bid_tab).toLowerCase();
        setNotifications((prev) =>
          prev.filter((item) => {
            const itemModule = item.module || item.meta?.module;
            const itemTab = String(item.bid_tab || item.meta?.tab || item.meta?.status || "").toLowerCase();

            return itemModule !== payload.module || itemTab !== tab;
          })
        );
      }
    };

    const recoverStored = () => { if (document.visibilityState !== "hidden") void fetchStoredNotifications(); };
    window.addEventListener("notification-counts-updated", syncCountsHandler);
    window.addEventListener("outlook-mail-recover", recoverStored);
    window.addEventListener("hr-notifications-refresh", recoverStored);
    window.addEventListener("realtime-connected", recoverStored);
    window.addEventListener("focus", recoverStored);
    return () => {
      notificationEpochRef.current += 1;
      notificationsRequestRef.current?.abort();
      window.removeEventListener("notification-counts-updated", syncCountsHandler);
      window.removeEventListener("outlook-mail-recover", recoverStored);
      window.removeEventListener("hr-notifications-refresh", recoverStored);
      window.removeEventListener("realtime-connected", recoverStored);
      window.removeEventListener("focus", recoverStored);
    };
  }, [fetchStoredNotifications, isLoggedIn, userId]);

  const markNotificationRead = useCallback(async (id) => {
    if (!id) return;

    try {
      const token = localStorage.getItem("authToken");
      const actor = notificationActorRef.current;
      const { data } = await axios.post(
        `${API_URL}/notifications/mark-read`,
        { ids: [id] },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (actor !== notificationActorRef.current) return;
      // HR receipts are acknowledged only by the popup Close endpoint.
      if (data?.updated === 0) { window.dispatchEvent(new Event("hr-notifications-refresh")); return; }
      setUnreadCount((current) =>
        typeof data?.unread_count !== "undefined" ? Number(data.unread_count || 0) : Math.max(0, current - 1)
      );
      setNotifications((prev) => prev.filter((item) => String(item.id) !== String(id)));
      window.dispatchEvent(new CustomEvent("notification-counts-updated", {
        detail: { counts: data?.unread_counts || null, ids: [id] },
      }));
    } catch (error) {
      console.warn("Notification mark-read failed", error);
    }
  }, []);

  // 🧠 GLOBAL NOTIFICATION LISTENER (FINAL)
  useEffect(() => {
    const handler = (e) => {
      const data = e.detail;

      // ✅ correct user filter (backend updated)
      if (data?.user_id && Number(data.user_id) !== Number(userId)) return;
      if (data?.actor_type && data.actor_type !== actorType) return;
      if (!isOutlookNotificationAllowed(data)) return;

      // 🔔 SOUND
      if (data.sound) {
        const audio = new Audio("/notification.mp3");
        audio.play().catch(() => { });
      }

      // 🔢 unread count (future use)
      // console.log("Unread:", data.unread_count);
      // ✅ backend unread count use karo
      if (typeof data.unread_count !== "undefined") {
        setUnreadCount(data.unread_count);
      }

      // ✅ notification list maintain
      setNotifications(prev => {
        if (prev.find(n => n.id === data.id)) return prev;

        return [
          {
            id: data.id,
            message: data.message,
            msg_time: data.msg_time,
            url: data.url,
            read: false,
            meta: data.meta || {},
            module: data.meta?.module,
            bid_tab: data.meta?.tab || data.meta?.status,
          },
          ...prev
        ];
      });

      // setToasts(prev => {
      //   // duplicate रोकना
      //   if (prev.find(t => t.id === data.id)) return prev;

      //   const id = data.id;

      //   setTimeout(() => removeToast(id), 30000);

      //   return [
      //     ...prev,
      //     {
      //       id,
      //       message: data.message
      //     }
      //   ];
      // });
    };

    window.addEventListener("echo-event", handler);

    return () => window.removeEventListener("echo-event", handler);
  }, [actorType, userId, notificationScope]); // eslint-disable-line react-hooks/exhaustive-deps

  // ===============================
  // 🛰️ BroadcastChannel fallback (for slave tabs)
  // If this tab is not the Echo master, listen for relayed events
  // posted by App.js on `echo_channel`.
  // useEffect(() => {
  //   const echo = getEcho();
  //   if (echo) return; // master tab will get events directly via Echo

  //   const bc = new BroadcastChannel("echo_channel");

  //   bc.onmessage = (event) => {
  //     const data = event?.data || {};

  //     // 🔥 ADD THIS LINE EXACTLY HERE
  //     window.dispatchEvent(new CustomEvent("echo-event", { detail: data }));
  //     console.log("📡 SLAVE RECEIVED via BroadcastChannel:", data);
  //   };

  //   return () => {
  //     try { bc.close(); } catch (e) { /* ignore */ }
  //   };
  // }, [userId]);

  useEffect(() => {
    const name = localStorage.getItem("name");
    if (name) setUserName(name);
  }, []);

  useEffect(() => {
    if (!isLoggedIn || !user || isExternalVendorContact || !navigator.permissions) {
      setLocationBlocked(false);
      return;
    }

    const startOneShotCheck = () => {
      // 1 second safety check (single-shot style)
      if (locationPollRef.current) return;

      locationPollRef.current = setTimeout(async () => {
        try {
          const p = await navigator.permissions.query({ name: "geolocation" });
          if (p.state === "granted") {
            setLocationBlocked(false);
          }
        } catch { }
        // 🛑 always stop after one shot
        if (locationPollRef.current) {
          clearTimeout(locationPollRef.current);
          locationPollRef.current = null;
        }
      }, 1000);
    };

    const stopAnyTimer = () => {
      if (locationPollRef.current) {
        clearTimeout(locationPollRef.current);
        locationPollRef.current = null;
      }
    };

    const applyState = (state) => {
      if (state === "denied") {
        // ❌ Blocked → turant modal open
        setLocationBlocked(true);

        // ⏱️ start 1-sec safety check
        startOneShotCheck();

        // 🛑 modal open hote hi, hum continuous polling nahi rakhte
        // (timer khud 1 shot me clear ho jayega)
      } else if (state === "granted") {
        // ✅ Allowed → modal close, no polling
        setLocationBlocked(false);
        stopAnyTimer();
      } else {
        // "prompt" → strict mode: treat as blocked
        setLocationBlocked(true);
        startOneShotCheck();
      }
    };

    const setup = async () => {
      try {
        const status = await navigator.permissions.query({ name: "geolocation" });
        permissionStatusRef.current = status;

        // initial sync
        applyState(status.state);

        // 🔔 instant reaction (same tab / other tab)
        status.onchange = () => {
          applyState(status.state);
        };
      } catch (e) {
        console.warn("Permissions API not available", e);
      }
    };

    setup();

    return () => {
      if (permissionStatusRef.current) {
        permissionStatusRef.current.onchange = null;
      }
      stopAnyTimer();
    };
  }, [isLoggedIn, user?.id, isExternalVendorContact]);



  useEffect(() => {
    setNavbarType(fixedNavbar ? "sticky" : "static");
    const handleTransparentNavbar = () => {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    };
    window.addEventListener("scroll", handleTransparentNavbar);
    handleTransparentNavbar();
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const getElapsedSecondsFromBackend = (breakStartedAt) => {
    if (!breakStartedAt) return 0;

    const start = new Date(breakStartedAt).getTime();
    const now = Date.now();

    return Math.max(Math.floor((now - start) / 1000), 0);
  };

  // =====================================================
  // 🔁 PENDING APPROVAL POLLING (30 sec)
  // =====================================================

  const startPendingPolling = () => {
    if (pendingPollingRef.current) return; // already running

    pendingPollingRef.current = setInterval(async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) return;

        const { data } = await axios.get(
          `${API_URL}/attendance/status`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // 🔥 APPLY BACKEND TRUTH
        setLoginStatus(data);

        // setTimeout(() => {
        //   fetchActivityWatchAFK();
        // }, 500);

        // 🔥 ROUTE VISIBILITY (SESSION AWARE)
        if (data?.permissions) {
          localStorage.setItem(
            "route_visibility",
            JSON.stringify(data.permissions)
          );
        }

        setLoginModalOpen(Boolean(data?.show_popup));

        // if (data?.onBreak && data?.break_started_at) {
        //   setTimer(getElapsedSecondsFromBackend(data.break_started_at));
        // } else {
        //   setTimer(0);
        // }

      } catch (err) {
        console.error("Pending approval polling failed", err);
      }
    }, 10000); // ⏱️ 60 seconds
  };

  const stopPendingPolling = () => {
    if (pendingPollingRef.current) {
      clearInterval(pendingPollingRef.current);
      pendingPollingRef.current = null;
    }
  };


  useEffect(() => {

    const fetchLoginStatus = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) return;

        const { data } = await axios.get(
          `${API_URL}/attendance/status`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setLoginStatus(data);

        // 🔥 ACTIVITYWATCH CHECK
        setTimeout(() => {
          fetchActivityWatchAFK();
        }, 5000); // 5 sec after initial load (to allow other components to mount)

        // useEffect(() => {

        //   if (!loginStatus) return;

        //   fetchActivityWatchAFK();

        // }, [loginStatus]);

        // 🔥 ROUTE VISIBILITY (SESSION AWARE)
        if (data?.permissions) {
          localStorage.setItem(
            "route_visibility",
            JSON.stringify(data.permissions)
          );
        }

        setOnBreak(Boolean(data?.onBreak));

        if (data?.onBreak && data?.break_started_at) {
          setTimer(getElapsedSecondsFromBackend(data.break_started_at));
        } else {
          setTimer(0);
        }


        // 🟢 POPUP — STRICTLY backend driven
        setLoginModalOpen(Boolean(data?.show_popup));


      } catch (err) {
        console.error("checkLoginStatus failed", err);
      }
    };


    fetchLoginStatus();


  }, [isLoggedIn]);

  // useEffect(() => {
  //   if (!isLoggedIn) return;

  //   const check = async () => {
  //     try {
  //       await getLocation();
  //       setLocationBlocked(false);
  //     } catch {
  //       setLocationBlocked(true);
  //     }
  //   };

  //   check();
  // }, [isLoggedIn, loginStatus]);



  useEffect(() => {
    if (!loginStatus) return;

    const visibility = loginStatus.permissions;
    if (visibility && typeof visibility === "object") {
      localStorage.setItem("route_visibility", JSON.stringify(visibility));
      window.dispatchEvent(
        new CustomEvent("route-visibility-changed", { detail: visibility })
      );
    }
  }, [loginStatus?.permissions]);

  useEffect(() => {
    if (!loginStatus) return;

    // ✅ ONLY popup based early / late
    // ✅ BACKEND is single source of truth for minutes
    if (
      loginStatus.session === null &&
      (loginStatus.status === "early_login" || loginStatus.status === "late_login")
    ) {
      const baseMinutes =
        loginStatus.status === "late_login"
          ? Number(loginStatus.late_minutes ?? 0)
          : Number(loginStatus.early_minutes ?? 0);

      setDisplayMinutes(baseMinutes);

      const timer = setInterval(() => {
        setDisplayMinutes((prev) =>
          loginStatus.status === "late_login" ? prev + 1 : prev - 1
        );
      }, 15000);

      return () => clearInterval(timer);
    }

    // ✅ reset when popup not required
    setDisplayMinutes(0);


  }, [loginStatus]);

  useEffect(() => {
    if (!loginStatus) return;

    handleAutoLogout();

  }, [loginStatus]);

  // =====================================================
  // 🎯 START / STOP POLLING BASED ON STATUS
  // =====================================================
  useEffect(() => {
    if (!loginStatus) return;

    const isPendingApproval =
      loginStatus.session === null &&
      (
        loginStatus.status === "pending_early_login" ||
        loginStatus.status === "pending_late_login"
      );

    if (isPendingApproval) {
      // ✅ START polling
      startPendingPolling();
    } else {
      // 🛑 STOP polling
      stopPendingPolling();
    }

    // cleanup on unmount
    return () => {
      stopPendingPolling();
    };
  }, [loginStatus]);



  // ========================================
  // ⏭️ NEXT STATUS AUTO RECHECK (TOO EARLY)
  // ========================================
  useEffect(() => {
    if (!loginStatus) return;

    // 🧹 cleanup old timer
    if (nextStatusCheckTimerRef.current) {
      clearTimeout(nextStatusCheckTimerRef.current);
      nextStatusCheckTimerRef.current = null;
    }

    const attendanceStatusSeconds =
      (loginStatus.session === null || loginStatus.session === "attendance") &&
      (loginStatus.status === "work_finished" || loginStatus.status === "early_login" || loginStatus.status === "on_time" || loginStatus.status === "already_logged_in") &&
      Number(loginStatus.next_status_check_seconds) > 0
        ? Number(loginStatus.next_status_check_seconds)
        : 0;
    const vendorProjectSeconds = Number(loginStatus.vendor_projects_next_check_seconds);
    const nextChecks = [attendanceStatusSeconds, vendorProjectSeconds].filter(
      (seconds) => Number.isFinite(seconds) && seconds > 0
    );

    // Recheck at the earliest attendance or vendor-project visibility boundary.
    if (nextChecks.length > 0) {
      const seconds = Math.min(...nextChecks);

      nextStatusCheckTimerRef.current = setTimeout(async () => {
        try {
          const token = localStorage.getItem("authToken");
          if (!token) return;

          const { data } = await axios.get(
            `${API_URL}/attendance/status`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          // 🔥 APPLY BACKEND TRUTH
          setLoginStatus(data);

          // setTimeout(() => {
          //   fetchActivityWatchAFK();
          // }, 500);

          // 🔥 ROUTE VISIBILITY (SESSION AWARE)
          if (data?.permissions) {
            localStorage.setItem(
              "route_visibility",
              JSON.stringify(data.permissions)
            );
          }

          setLoginModalOpen(Boolean(data?.show_popup));

          // if (data?.onBreak && data?.break_started_at) {
          //   setTimer(getElapsedSecondsFromBackend(data.break_started_at));
          // } else {
          //   setTimer(0);
          // }

        } catch (err) {
          console.error("Next status auto recheck failed", err);
        }
      }, seconds * 1000);
    }

    // cleanup on change / unmount
    return () => {
      if (nextStatusCheckTimerRef.current) {
        clearTimeout(nextStatusCheckTimerRef.current);
        nextStatusCheckTimerRef.current = null;
      }
    };

  }, [loginStatus]);


  // ========================================
  // ⏱️ BREAK TIMER (1 sec → continuous)
  // ========================================
  useEffect(() => {
    let interval = null;

    if (onBreak) {
      interval = setInterval(() => {
        setTimer((prev) => prev + 1); // 1 sec increment
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [onBreak]);

  // =====================================================
  // 🆕 ROUTE CHANGE PAR AFK FETCH (2 sec delay)
  // =====================================================
  useEffect(() => {
    if (!isLoggedIn || !loginStatus) return;

    const timer = setTimeout(() => {
      fetchActivityWatchAFK();
    }, 2000);

    return () => clearTimeout(timer);

  }, [location.pathname, loginStatus]);


  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfigurator = () => setOpenConfigurator(dispatch, !openConfigurator);
  // const handleOpenMenu = (e) => setOpenMenu(e.currentTarget);
  const handleOpenMenu = (e) => {
    setOpenMenu(e.currentTarget);

      // ✅ UI sync

      // ✅ OPTIONAL: mark all read locally

  };
  const handleCloseMenu = () => setOpenMenu(false);
  const removeToast = (id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  };

  // const handleStartBreak = async () => {
  //   setLoading(true);
  //   try {
  //     const token = localStorage.getItem("authToken");

  //     if (loginStatus?.session === "attendance") {
  //       await axios.post(
  //         `${API_URL}/attendance/break/start`,
  //         {},
  //         { headers: { Authorization: `Bearer ${token}` } }
  //       );
  //     }

  //     if (loginStatus?.session === "overtime") {
  //       await axios.post(
  //         `${API_URL}/overtime/break/start`,
  //         {},
  //         { headers: { Authorization: `Bearer ${token}` } }
  //       );
  //     }

  //     // 🔄 ALWAYS refresh truth
  //     const { data } = await axios.get(
  //       `${API_URL}/attendance/status`,
  //       { headers: { Authorization: `Bearer ${token}` } }
  //     );

  //     setLoginStatus(data);

  //     // 🔥 ROUTE VISIBILITY (SESSION AWARE)
  //     if (data?.permissions) {
  //       localStorage.setItem(
  //         "route_visibility",
  //         JSON.stringify(data.permissions)
  //       );
  //     }

  //     setOnBreak(Boolean(data.onBreak));

  //     if (data?.onBreak && data?.break_started_at) {
  //       setTimer(getElapsedSecondsFromBackend(data.break_started_at));
  //     } else {
  //       setTimer(0);
  //     }


  //   } catch (err) {
  //     console.error("Break start failed", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const handleStartBreak = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const endpoint =
        loginStatus?.session === "overtime" ? "overtime" : "attendance";

      await axios.post(
        `${API_URL}/${endpoint}/break/start`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // ✅ 1. INSTANT UI FEEDBACK
      setOnBreak(true);
      setTimer(0);

      // ✅ 2. BACKEND TRUTH
      const { data } = await axios.get(
        `${API_URL}/attendance/status`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setLoginStatus(data);

      // ✅ 3. DEFENSIVE SYNC
      if (data?.onBreak === false) {
        setOnBreak(false);
        setTimer(0);
      }

    } catch (err) {
      console.error("Break start failed", err);
    } finally {
      setLoading(false);
    }
  };



  const handleEndBreak = async () => {
    try {
      const token = localStorage.getItem("authToken");

      if (loginStatus?.session === "attendance") {
        await axios.post(
          `${API_URL}/attendance/break/end`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      if (loginStatus?.session === "overtime") {
        await axios.post(
          `${API_URL}/overtime/break/end`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      const { data } = await axios.get(
        `${API_URL}/attendance/status`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setLoginStatus(data);

      // 🔥 ROUTE VISIBILITY (SESSION AWARE)
      if (data?.permissions) {
        localStorage.setItem(
          "route_visibility",
          JSON.stringify(data.permissions)
        );
      }

      setOnBreak(Boolean(data.onBreak));
      setTimer(0);

    } catch (err) {
      console.error("Failed to end break", err);
    }
  };


  const autoLogoutTimerRef = useRef(null);
  const nextStatusCheckTimerRef = useRef(null);
  const afkBucketRef = useRef(null);

  // const getAFKBucket = async () => {
  //   try {

  //     // 🔹 already detected → reuse
  //     if (afkBucketRef.current) {
  //       return afkBucketRef.current;
  //     }

  //     const res = await fetch("http://localhost:5600/api/0/buckets");

  //     if (!res.ok) return null;

  //     const buckets = await res.json();

  //     const bucketId = Object.keys(buckets).find((b) =>
  //       b.startsWith("aw-watcher-afk")
  //     );

  //     if (bucketId) {
  //       afkBucketRef.current = bucketId;
  //     }

  //     return bucketId || null;

  //   } catch {
  //     return null;
  //   }
  // };

  // =====================================================
  // 🔥 ACTIVITYWATCH AFK FETCH
  // =====================================================
  // const fetchActivityWatchAFK = async () => {
  //   try {

  //     // ❌ guard rules
  //     if (!loginStatus) return;
  //     if (loginStatus.status !== "already_logged_in") return;
  //     if (loginStatus.onBreak === true) return;

  //     // const res = await fetch("http://localhost:5600/api/0/buckets/aw-watcher-afk/events");

  //     const bucketId = await getAFKBucket();

  //     if (!bucketId) return;

  //     // const res = await fetch(
  //     //   `http://localhost:5600/api/0/buckets/${bucketId}/events`
  //     // );

  //     const now = new Date();

  //     const startOfDay = new Date();
  //     startOfDay.setHours(0, 0, 0, 0);

  //     const res = await fetch(
  //       `http://localhost:5600/api/0/buckets/${bucketId}/events?start=${startOfDay.toISOString()}&end=${now.toISOString()}`
  //     );

  //     if (!res.ok) return;

  //     const events = await res.json();

  //     if (!Array.isArray(events)) return;

  //     // 🔎 filter afk + duration >= 60
  //     const filtered = events.filter(
  //       (e) =>
  //         e?.data?.status === "afk" &&
  //         Number(e?.duration) >= 60
  //     );

  //     if (filtered.length === 0) return;

  //     const payload = filtered.map((e) => ({
  //       source_event_id: e.id,
  //       timestamp: e.timestamp,
  //       duration_sec: Math.floor(e.duration),
  //     }));

  //     const token = localStorage.getItem("authToken");

  //     await axios.post(
  //       `${API_URL}/activitywatch/idle-logs`,
  //       {
  //         session: loginStatus?.session,
  //         logs: payload,
  //       },
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );

  //   } catch (err) {
  //     console.warn("ActivityWatch fetch failed", err);
  //   }
  // };

  const getAFKBucket = async () => {
    console.log('🔍 getAFKBucket() called');
    try {
      if (afkBucketRef.current) {
        console.log('✅ Using cached bucket:', afkBucketRef.current);
        return afkBucketRef.current;
      }

      console.log('🌐 Fetching buckets from ActivityWatch...');
      const res = await fetch("http://localhost:5600/api/0/buckets");

      if (!res.ok) {
        console.log('❌ Bucket fetch failed:', res.status, res.statusText);
        return null;
      }

      const buckets = await res.json();
      console.log('📦 Available buckets:', Object.keys(buckets));

      const bucketId = Object.keys(buckets).find((b) =>
        b.startsWith("aw-watcher-afk")
      );

      if (bucketId) {
        console.log('✅ Found AFK bucket:', bucketId);
        afkBucketRef.current = bucketId;
      } else {
        console.log('❌ No AFK bucket found in buckets');
      }

      return bucketId || null;

    } catch (err) {
      console.warn('❌ Error in getAFKBucket:', err);
      return null;
    }
  };

  // const fetchActivityWatchAFK = async () => {
  //   console.log('🚀 fetchActivityWatchAFK() started');

  //   try {
  //     // ❌ guard rules
  //     if (!loginStatus) {
  //       console.log('❌ loginStatus is null, returning');
  //       return;
  //     }
  //     if (loginStatus.status !== "already_logged_in") {
  //       console.log('❌ status not already_logged_in:', loginStatus.status);
  //       return;
  //     }
  //     if (loginStatus.onBreak === true) {
  //       console.log('❌ user is on break, returning');
  //       return;
  //     }

  //     console.log('✅ Guard checks passed, fetching bucket...');
  //     const bucketId = await getAFKBucket();
  //     console.log('📦 bucketId:', bucketId);

  //     if (!bucketId) {
  //       console.log('❌ No AFK bucket found, returning');
  //       return;
  //     }

  //     const now = new Date();
  //     const startOfDay = new Date();
  //     startOfDay.setHours(0, 0, 0, 0);

  //     // const url = `http://localhost:5600/api/0/buckets/${bucketId}/events?start=${startOfDay.toISOString()}&end=${now.toISOString()}`;
  //     console.log('🌐 Fetching from ActivityWatch:', url);

  //     const res = await fetch(url);

  //     if (!res.ok) {
  //       console.log('❌ ActivityWatch response not OK:', res.status, res.statusText);
  //       return;
  //     }

  //     const events = await res.json();
  //     console.log(`📊 Received ${events.length} events from ActivityWatch`);

  //     if (!Array.isArray(events)) {
  //       console.log('❌ Events is not an array');
  //       return;
  //     }

  //     // 🔎 filter afk + duration >= 60
  //     const filtered = events.filter(
  //       (e) =>
  //         e?.data?.status === "afk" &&
  //         Number(e?.duration) >= 60
  //     );

  //     console.log(`🔍 Filtered ${filtered.length} AFK events with duration >= 60`);

  //     if (filtered.length === 0) {
  //       console.log('⏸️ No matching events, returning');
  //       return;
  //     }

  //     const payload = filtered.map((e) => ({
  //       source_event_id: e.id,
  //       timestamp: e.timestamp,
  //       duration_sec: Math.floor(e.duration),
  //     }));

  //     console.log('📦 Payload prepared:', payload);

  //     const token = localStorage.getItem("authToken");
  //     if (!token) {
  //       console.log('❌ No auth token, returning');
  //       return;
  //     }

  //     console.log('📤 Sending to backend:', `${API_URL}/activitywatch/idle-logs`);
  //     const response = await axios.post(
  //       `${API_URL}/activitywatch/idle-logs`,
  //       {
  //         session: loginStatus?.session,
  //         logs: payload,
  //       },
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );

  //     console.log('✅ Backend response:', response.data);

  //   } catch (err) {
  //     console.warn('❌ ActivityWatch fetch failed:', err);
  //   }
  // };



  const fetchActivityWatchAFK = async () => {
    console.log('🚀 fetchActivityWatchAFK() started');
    try {
      // ❌ Guard rules
      if (!loginStatus) {
        console.log('❌ loginStatus is null, returning');
        return;
      }
      if (loginStatus.status !== "already_logged_in") {
        console.log('❌ status not already_logged_in:', loginStatus.status);
        return;
      }
      if (loginStatus.onBreak === true) {
        console.log('❌ user is on break, returning');
        return;
      }

      // =========================================================
      // 🎯 Determine start time – today's "in" time from timeline
      // =========================================================
      let startTime;
      const todayLogicalDate = loginStatus.logical_date; // e.g., "2026-03-07"
      const currentSession = loginStatus.session;        // "attendance" or "overtime"

      if (todayLogicalDate && Array.isArray(loginStatus.timeline)) {
        // Find today's entry that matches the current session type
        const todayEntry = loginStatus.timeline.find(
          entry => entry.date === todayLogicalDate && entry.type === currentSession
        );
        if (todayEntry && todayEntry.in) {
          // Parse "in" time like "17:41:25"
          const [hours, minutes, seconds] = todayEntry.in.split(':').map(Number);
          const [year, month, day] = todayLogicalDate.split('-').map(Number);
          // Create Date object in LOCAL time (browser's timezone)
          startTime = new Date(year, month - 1, day, hours, minutes, seconds);
          console.log(`✅ Using login time as start: ${startTime.toISOString()}`);
        }
      }

      // Fallback if no valid "in" time found (e.g., missing timeline)
      if (!startTime) {
        startTime = new Date();
        startTime.setHours(0, 0, 0, 0); // start of day
        console.log('⚠️ No login time found, using start of day');
      }

      const now = new Date();

      // =========================================================
      // 🔍 Fetch AFK bucket and events
      // =========================================================
      console.log('✅ Guard checks passed, fetching bucket...');
      const bucketId = await getAFKBucket();
      if (!bucketId) {
        console.log('❌ No AFK bucket found, returning');
        return;
      }

      const url = `http://localhost:5600/api/0/buckets/${bucketId}/events?start=${startTime.toISOString()}&end=${now.toISOString()}`;
      console.log('🌐 Fetching from ActivityWatch:', url);

      const res = await fetch(url);
      if (!res.ok) {
        console.log('❌ ActivityWatch response not OK:', res.status, res.statusText);
        return;
      }

      const events = await res.json();
      console.log(`📊 Received ${events.length} events from ActivityWatch`);

      if (!Array.isArray(events)) {
        console.log('❌ Events is not an array');
        return;
      }

      // 🔎 Filter AFK events with duration >= 60 seconds
      // const filtered = events.filter(
      //   (e) => e?.data?.status === "afk" && Number(e?.duration) >= 60
      // );
      const filtered = events
        .filter(e => e?.data?.status === "afk")   // only idle
        .filter(e => Number(e?.duration) >= 60);  // minimum 60 sec

      // console.log("AFK events only:", filtered);
      console.log(`🔍 Filtered ${filtered.length} AFK events with duration >= 60`);

      if (filtered.length === 0) {
        console.log('⏸️ No matching events, returning');
        return;
      }

      const payload = filtered.map((e) => ({
        source_event_id: e.id,
        timestamp: e.timestamp,
        duration_sec: Math.floor(Number(e.duration)),
      }));
      console.log('📦 Payload prepared:', payload);

      const token = localStorage.getItem("authToken");
      if (!token) {
        console.log('❌ No auth token, returning');
        return;
      }

      console.log('📤 Sending to backend:', `${API_URL}/activitywatch/idle-logs`);
      const response = await axios.post(
        `${API_URL}/activitywatch/idle-logs`,
        {
          session: loginStatus?.session,
          logs: payload,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log('✅ Backend response:', response.data);

    } catch (err) {
      console.warn('❌ ActivityWatch fetch failed:', err);
    }
  };

  useEffect(() => {
    return () => {
      if (autoLogoutTimerRef.current) {
        clearTimeout(autoLogoutTimerRef.current);
        autoLogoutTimerRef.current = null;
      }
      // 🧹 stop pending approval polling
      stopPendingPolling();
    };
  }, []);


  const handleAutoLogout = () => {
    // 🛑 cleanup old timer
    if (autoLogoutTimerRef.current) {
      clearTimeout(autoLogoutTimerRef.current);
      autoLogoutTimerRef.current = null;
    }

    const seconds = Number(loginStatus?.auto_logout_after_seconds);

    // ❌ no seconds → nothing to do
    if (!seconds || seconds <= 0) {
      return;
    }

    autoLogoutTimerRef.current = setTimeout(async () => {

      // 🔥 FINAL AFK FETCH BEFORE AUTO LOGOUT
      await fetchActivityWatchAFK();


      try {
        const token = localStorage.getItem("authToken");

        // 🌍 get location (same as manual logout)
        const coords = await getLocation();
        // ================================
        // 🔹 SEND ACTIVITY SUMMARY (BEFORE AUTO LOGOUT)
        // ================================
        try {
          if (activityCounts && Object.keys(activityCounts).length > 0) {
            await axios.post(
              `${API_URL}/activity-summary`,
              {
                session: loginStatus?.session, // "attendance" or "overtime"
                counts: activityCounts,
              },
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );
          }
        } catch (e) {
          console.warn("Activity summary send failed (auto logout)", e);
        }

        // ======================================
        // 🔥 BACKEND-AWARE AUTO LOGOUT
        // ======================================
        if (loginStatus?.session === "overtime") {
          await axios.post(
            `${API_URL}/overtime/logout`,
            {
              type: "auto",
              latitude: coords.latitude,
              longitude: coords.longitude,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
        }

        if (loginStatus?.session === "attendance") {
          await axios.post(
            `${API_URL}/attendance/logout`,
            {
              type: "auto",
              latitude: coords.latitude,
              longitude: coords.longitude,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
        }

        // ======================================
        // 🔚 FRONTEND LOGOUT (ALWAYS)
        // ======================================

        setActivityCounts({});

        // 🔚 FRONTEND LOGOUT
        localStorage.removeItem("route_visibility");
        await authLogout();
        navigate("/authentication/sign-in/illustration", { replace: true });

      } catch (err) {
        // 🔚 FRONTEND LOGOUT
        localStorage.removeItem("route_visibility");
        // 🛑 Hard safety — never keep user logged in
        await authLogout();
        navigate("/authentication/sign-in/illustration", { replace: true });
      }
    }, seconds * 1000);
  };



  // =====================================================
  // 🎯 EXACT BACKEND-DRIVEN HIDE RULES
  // =====================================================

  const showStartBreakButton =
    loginStatus?.break_allowed === true &&
    loginStatus?.onBreak === false &&
    (loginStatus?.session === "attendance" ||
      loginStatus?.session === "overtime");

  const showLogoutButton = loginStatus?.manual_logout_allowed === true;


  // const getLocation = () => {
  //   return new Promise((resolve) => {
  //     if (!navigator.geolocation) {
  //       resolve({ latitude: null, longitude: null });
  //       return;
  //     }

  //     navigator.geolocation.getCurrentPosition(
  //       (pos) =>
  //         resolve({
  //           latitude: pos.coords.latitude,
  //           longitude: pos.coords.longitude,
  //         }),
  //       () => resolve({ latitude: null, longitude: null })
  //     );
  //   });
  // };


  const getLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation not supported"));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          resolve({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
          });
        },
        (err) => {
          reject(err); // user denied / blocked
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    });
  };


  // MANUAL LOGOUT ORIGINAL RULE RESTORED
  const handleLogout = async () => {
    setLogoutLoading(true);

    try {
      const token = localStorage.getItem("authToken");
      // ============================================
      // ❌ SAFETY: logout button dikha hi nahi
      // ============================================
      if (loginStatus?.manual_logout_allowed !== true) {
        return;
      }

      // ============================================
      // 🔥 API BASED LOGOUT (ATTENDANCE / OVERTIME)
      // ============================================
      if (loginStatus?.manual_logout_api === true) {
        let coords;
        try {
          coords = await getLocation();
        } catch (e) {
          setLocationBlocked(true);
          return;
        }

        // 🔥 FINAL AFK FETCH BEFORE LOGOUT
        await fetchActivityWatchAFK();

        // ================================
        // 🔹 SEND ACTIVITY SUMMARY (BEFORE LOGOUT)
        // ================================
        try {
          if (activityCounts && Object.keys(activityCounts).length > 0) {
            await axios.post(
              `${API_URL}/activity-summary`,
              {
                session: loginStatus.session, // "attendance" or "overtime"
                counts: activityCounts,
              },
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );
          }
        } catch (e) {
          console.warn("Activity summary send failed (manual logout)", e);
        }



        // 🔹 ATTENDANCE LOGOUT
        if (loginStatus.session === "attendance") {
          await axios.post(
            `${API_URL}/attendance/logout`,
            {
              type: "manual",
              latitude: coords.latitude,
              longitude: coords.longitude,
              session: "attendance",
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
        }

        // 🔹 OVERTIME LOGOUT
        if (loginStatus.session === "overtime") {
          await axios.post(
            `${API_URL}/overtime/logout`,
            {
              latitude: coords.latitude,
              longitude: coords.longitude,
              session: "overtime",
              type: "manual",
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
        }

        setActivityCounts({});

        // 🔚 FRONTEND LOGOUT
        localStorage.removeItem("route_visibility");
        // 🔚 FRONTEND LOGOUT
        await authLogout();
        navigate("/authentication/sign-in/illustration", { replace: true });
        return;
      }

      // ============================================
      // 🟡 FRONTEND-ONLY LOGOUT (NO API)
      // ============================================
      // 🔚 FRONTEND LOGOUT
      localStorage.removeItem("route_visibility");
      await authLogout();
      navigate("/authentication/sign-in/illustration", { replace: true });

    } catch (err) {
      console.error("Logout failed", err);
    } finally {
      setLogoutLoading(false);
    }
  };


  const renderMenu = () => (
    // <Menu
    //   anchorEl={openMenu}
    //   anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    //   open={Boolean(openMenu)}
    //   onClose={handleCloseMenu}
    //   sx={{ mt: 2 }}
    // >

    //   {notifications.length === 0 && (
    //     <SoftTypography px={2} py={1}>
    //       No Notifications
    //     </SoftTypography>
    //   )}

    //   {notifications.map((n) => (
    //     <SoftBox
    //       key={n.id}
    //       display="flex"
    //       justifyContent="space-between"
    //       alignItems="center"
    //     >
    //       <NotificationItem
    //         title={[n.message]}
    //         date={n.msg_time}
    //       />

    //       {/* ❌ CLOSE BUTTON */}
    //       <span
    //         style={{
    //           cursor: "pointer",
    //           padding: "0 10px",
    //           fontWeight: "bold"
    //         }}
    //         onClick={() => {
    //           setNotifications(prev => prev.filter(item => item.id !== n.id));
    //         }}
    //       >
    //         ✖
    //       </span>
    //     </SoftBox>
    //   ))}
    //   {/* <NotificationItem
    //     // image={<img src={team2} alt="person" />}
    //     // title={["New message", "from Laur"]}
    //     // title={[notifications[0]?.message || "No message"]}
    //     // date="13 minutes ago"
    //     // onClick={handleCloseMenu}

    //   /> */}
    //   {/* <NotificationItem
    //     // image={<img src={logoSpotify} alt="logo" />}
    //     title={["New album", "by Travis Scott"]}
    //     date="1 day"
    //     onClick={handleCloseMenu}
    //   />
    //   <NotificationItem
    //     color="secondary"
    //     image={<Icon fontSize="small">payment</Icon>}
    //     title={["", "Payment successfully completed"]}
    //     date="2 days"
    //     onClick={handleCloseMenu}
    //   /> */}
    // </Menu>


    // <Menu
    //   anchorEl={openMenu}
    //   anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    //   open={Boolean(openMenu)}
    //   onClose={handleCloseMenu}
    //   sx={{ mt: 2 }}
    // >
    <Menu
      anchorEl={openMenu}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
      PaperProps={{
        sx: {
          maxHeight: 400,   // 🔥 approx 10 items
          overflowY: "auto",
          // width: 320,
        },
      }}
    >
      {notifications.filter(isOutlookNotificationAllowed).length === 0 ? (
        <NotificationItem
          title={["No Notifications"]}
          date=""
          image={false}
          sx={{
            "& .MuiTypography-root, & .MuiTypography-root *": {
              fontWeight: "400 !important",   // 🔥 force remove bold
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: 1.4,
            }
          }}
        />
      ) : (
        notifications.filter(isOutlookNotificationAllowed).map((n) => (
          <NotificationItem
            key={n.id}
            className={n.meta?.module === "outlook_mail" ? "outlook-mail-notification" : undefined}
            title={[n.message]}   // same rakho
            date={n.meta?.module === "outlook_mail" && n.meta?.event_at ? `${n.msg_time} · Email: ${formatMailTime(n.meta.event_at)}` : n.msg_time}
            image={false}
            // onClick={handleCloseMenu}
            onClick={async () => {
              const actor = notificationActorRef.current;
              handleCloseMenu();
              await markNotificationRead(n.id);

              // ✅ redirect from backend url
              if (n.url && actor === notificationActorRef.current) {
                navigate(n.url);
              }
            }}

            sx={{
              "& .MuiTypography-root, & .MuiTypography-root *": {
                fontWeight: "400 !important",   // 🔥 force remove bold
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.4,
                ...(n.meta?.module === "outlook_mail" ? { textTransform: "none !important" } : {}),
              }
            }}
          />
        ))
      )}
    </Menu>


  );

  return (
    <AppBar position={absolute ? "absolute" : navbarType} color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      {/* <div style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 9999
      }}>
        {toasts.map((t) => (
          <div
            key={t.id}
            style={{
              background: '#323232',
              color: '#fff',
              padding: '12px 16px',
              marginBottom: 10,
              borderRadius: 6,
              minWidth: 260,
              boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
              cursor: 'pointer'
            }}

            // onMouseEnter={() => clearTimeout(t.timeout)} // pause
            // onMouseEnter={() => {
            //   if (t.timeout) clearTimeout(t.timeout);
            // }}
            onMouseEnter={() => { }}
            // onMouseLeave={() => removeToast(t.id)} // mouse leave close

            // onMouseLeave={() => {
            //   if (t.timeout) clearTimeout(t.timeout);

            //   t.timeout = setTimeout(() => {
            //     removeToast(t.id);
            //   }, 3000); // 3 sec resume
            // }}
            onMouseLeave={() => {
              setTimeout(() => removeToast(t.id), 3000);
            }}
          >
            {t.message}

            <span
              style={{
                float: 'right',
                marginLeft: 10,
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
              // onClick={() => removeToast(t.id)} // manual close
              // onClick={() => {
              //   if (t.timeout) clearTimeout(t.timeout);
              //   removeToast(t.id);
              // }}

              onClick={() => removeToast(t.id)}
            >
              ✖
            </span>
          </div>
        ))}
      </div> */}
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <SoftBox
          color="inherit"
          mb={{ xs: 1, md: 0 }}
          sx={(theme) => navbarRow(theme, { isMini })}
        >
          {/* <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} /> */}
          <Icon fontSize="medium" sx={navbarDesktopMenu} onClick={handleMiniSidenav}>
            {miniSidenav ? "menu_open" : "menu"}
          </Icon>
        </SoftBox>

        {!isMini && (
          <SoftBox sx={(theme) => navbarRow(theme, { isMini })}>
            <SoftBox color={light ? "white" : "inherit"}>
              {isLoggedIn ? (
                <>
                  {userName && (
                    <SoftTypography variant="button" fontWeight="medium"
                      color={light ? "white" : "dark"}
                      sx={{ mr: 2, display: "inline-block" }}
                    >
                      Welcome - {userName}
                    </SoftTypography>
                  )}

                  {showStartBreakButton && (

                    <IconButton
                      sx={{ ...navbarIconButton, mr: 1 }}
                      size="small"
                      onClick={handleStartBreak}
                      disabled={loading}
                    >
                      <Icon sx={{ color: light ? "#fff" : "#1e293b" }}>
                        {loading ? "hourglass_top" : "pause_circle"}
                      </Icon>
                      <SoftTypography
                        variant="button"
                        fontWeight="medium"
                        color={light ? "white" : "dark"}
                        ml={0.5}
                      >
                        {loading ? "Starting..." : "Start Break"}
                      </SoftTypography>
                    </IconButton>
                  )}

                  {showLogoutButton && (
                    <IconButton
                      sx={navbarIconButton}
                      size="small"
                      onClick={handleLogout}
                      disabled={logoutLoading}
                    >
                      <Icon sx={{ color: light ? "#fff" : "#1e293b" }}>
                        {logoutLoading ? "hourglass_top" : "logout"}
                      </Icon>
                      <SoftTypography variant="button" fontWeight="medium"
                        color={light ? "white" : "dark"} ml={0.5}
                      >
                        {logoutLoading ? "Logging out..." : "Logout"}
                      </SoftTypography>
                    </IconButton>
                  )}

                  <ProjectLiveChatInboxMenu light={light} />
                </>
              ) : (
                <Link to="/authentication/sign-in/illustration">
                  <IconButton sx={navbarIconButton} size="small">
                    <Icon sx={{ color: light ? "#fff" : "#1e293b" }}>account_circle</Icon>
                    <SoftTypography variant="button" fontWeight="medium"
                      color={light ? "white" : "dark"} ml={0.5}
                    >
                      Sign in
                    </SoftTypography>
                  </IconButton>
                </Link>
              )}

              <IconButton size="small" color="inherit"
                sx={navbarMobileMenu} onClick={handleMiniSidenav}
              >
                <Icon className={light ? "text-white" : "text-dark"}>
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>

              <IconButton size="small" color="inherit"
                sx={navbarIconButton} onClick={handleConfigurator}
              >
                <Icon>settings</Icon>
              </IconButton>

              {/* <IconButton size="small" color="inherit"
                sx={navbarIconButton} onClick={handleOpenMenu}
              >
                <Icon className={light ? "text-white" : "text-dark"}>notifications</Icon>
              </IconButton> */}
              <IconButton
                size="small"
                color="inherit"
                sx={{ ...navbarIconButton, position: "relative" }}
                onClick={handleOpenMenu}
              >
                <Icon className={light ? "text-white" : "text-dark"}>
                  notifications
                </Icon>

                {unreadCount > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: 2,
                      right: 2,
                      background: "red",
                      color: "#fff",
                      borderRadius: "50%",
                      fontSize: 10,
                      padding: "2px 6px",
                      minWidth: 18,
                      textAlign: "center"
                    }}
                  >
                    {unreadCount}
                  </span>
                )}
              </IconButton>

              {renderMenu()}
            </SoftBox>
          </SoftBox>
        )}
      </Toolbar>

      {/* <Modal open={loginModalOpen} onClose={() => { }}> */}
      <Modal open={loginModalOpen && !locationBlocked} onClose={() => { }}>
        <SoftBox
          style={{
            background: "white",
            padding: 30,
            maxWidth: 400,
            margin: "10% auto",
            borderRadius: 10,
            textAlign: "center",
          }}
        >
          {loginStatus?.status?.startsWith("pending_") && (
            <>
              <SoftTypography variant="h6" mb={2}>
                Your login request has been sent
              </SoftTypography>
              <SoftTypography variant="body2" color="info">
                Please wait for approval from Team Leader / Manager / Admin.
              </SoftTypography>
            </>
          )}

          {loginStatus?.status === "on_time" && loginStatus?.session === "attendance" && (

            <>
              <SoftTypography variant="h6" mb={2}>
                Mark Attendance
              </SoftTypography>
              <Button
                variant="contained"
                color="success"
                fullWidth
                disabled={actionLoading}
                onClick={async () => {
                  try {
                    setActionLoading(true);
                    setActionText("Marking Attendance...");

                    const token = localStorage.getItem("authToken");
                    // const coords = await getLocation();
                    let coords;
                    try {
                      coords = await getLocation();
                    } catch (e) {
                      setLocationBlocked(true);
                      return;
                    }


                    // ================================
                    // 1️⃣ MARK ATTENDANCE (EXPLICIT)
                    // ================================
                    const res = await axios.post(
                      `${API_URL}/attendance/mark`,
                      {
                        action: "mark_attendance",
                        latitude: coords.latitude,
                        longitude: coords.longitude,
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    );

                    // If backend blocked attendance due to gap, show gap modal
                    if (res?.data?.block_attendance) {
                      setGapMessage(res?.data?.message || "");
                      setGapMissingDays(res?.data?.missing_days ?? null);
                      setGapModalOpen(true);
                      setGapReason("");
                      return;
                    }

                    // ================================
                    // 2️⃣ FETCH FRESH STATUS (MANDATORY)
                    // ================================
                    const { data } = await axios.get(
                      `${API_URL}/attendance/status`,
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    );

                    // ================================
                    // 3️⃣ APPLY BACKEND TRUTH
                    // ================================
                    setLoginStatus(data);

                    // 🔥 ROUTE VISIBILITY (SESSION AWARE)
                    if (data?.permissions) {
                      localStorage.setItem(
                        "route_visibility",
                        JSON.stringify(data.permissions)
                      );
                    }

                    setLoginModalOpen(Boolean(data?.show_popup));

                  } catch (err) {
                    console.error("Attendance mark failed", err);
                  } finally {
                    setActionLoading(false);
                    setActionText("");
                  }
                }}
              >
                {actionLoading ? actionText : "Mark Attendance"}
              </Button>


            </>
          )}

          {loginStatus?.status === "on_time" && loginStatus?.session === "overtime" && (
            <>
              <SoftTypography variant="h6" mb={2} color="info">
                Mark Overtime Attendance
              </SoftTypography>

              <Button
                variant="contained"
                color="info"
                fullWidth
                disabled={actionLoading}
                onClick={async () => {
                  try {
                    setActionLoading(true);
                    setActionText("Marking Overtime Attendance...");
                    //const coords = await getLocation();
                    let coords;
                    try {
                      coords = await getLocation();
                    } catch (e) {
                      setLocationBlocked(true);
                      return;
                    }

                    await axios.post(
                      `${API_URL}/attendance/mark`,
                      {
                        action: "mark_overtime",
                        latitude: coords.latitude,
                        longitude: coords.longitude,
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                        },
                      }
                    );

                    // 🔄 OT mark hone ke baad fresh status lao
                    const { data } = await axios.get(
                      `${API_URL}/attendance/status`,
                      {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                        },
                      }
                    );

                    setLoginStatus(data);

                    // 🔥 ROUTE VISIBILITY (SESSION AWARE)
                    if (data?.permissions) {
                      localStorage.setItem(
                        "route_visibility",
                        JSON.stringify(data.permissions)
                      );
                    }

                    setLoginModalOpen(Boolean(data?.show_popup));

                  } finally {
                    setActionLoading(false);
                    setActionText("");
                  }
                }}
              >
                {actionLoading ? actionText : "Mark Overtime Attendance"}
              </Button>

            </>
          )}


          {loginStatus?.status === "early_login" && loginStatus?.session === null && (
            <>
              <SoftTypography variant="h6" mb={1} color="warning">
                {"You are early!"}
              </SoftTypography>

              <SoftTypography variant="body2" mb={2}>
                You are <strong>{Number(displayMinutes).toFixed(2)}</strong> minutes early
              </SoftTypography>

              <TextField
                fullWidth
                multiline
                rows={3}
                label="Reason"
                value={loginComment}
                onChange={(e) => setLoginComment(e.target.value)}
                sx={{ mb: 2 }}
              />
              <Button
                variant="contained"
                disabled={actionLoading}
                onClick={async () => {
                  try {
                    setActionLoading(true);
                    setActionText("Sending Early Request...");

                    const token = localStorage.getItem("authToken");

                    // ✅ STEP-1: EARLY LOGIN REQUEST (JUST LIKE LATE)
                    await axios.post(
                      `${API_URL}/attendance/request-earlylogin`,
                      {
                        type: "early_login",
                        comment: loginComment,
                        minutes: Math.round(Number(loginStatus.early_minutes ?? 0)),
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    );

                    // ✅ STEP-2: ALWAYS FETCH FRESH STATUS
                    const { data } = await axios.get(
                      `${API_URL}/attendance/status`,
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    );

                    // ✅ STEP-3: APPLY BACKEND TRUTH
                    setLoginStatus(data);

                    // 🔥 ROUTE VISIBILITY (SESSION AWARE)
                    if (data?.permissions) {
                      localStorage.setItem(
                        "route_visibility",
                        JSON.stringify(data.permissions)
                      );
                    }

                    setLoginModalOpen(Boolean(data?.show_popup));

                  } finally {
                    setActionLoading(false);
                    setActionText("");
                  }
                }}
              >
                {actionLoading ? actionText : "Request Early Approval"}
              </Button>


            </>
          )}

          {loginStatus?.status === "late_login" && loginStatus?.session === null && (
            <>
              <SoftTypography variant="h6" mb={1} color="error">
                {"You are late!"}
              </SoftTypography>

              <SoftTypography variant="body2" mb={2}>
                You are <strong>{Number(displayMinutes).toFixed(2)}</strong> minutes late
              </SoftTypography>

              <TextField
                fullWidth
                multiline
                rows={3}
                label="Reason"
                value={loginComment}
                onChange={(e) => setLoginComment(e.target.value)}
                sx={{ mb: 2 }}
              />
              <Button
                variant="contained"
                color="warning"
                disabled={actionLoading}
                onClick={async () => {
                  try {
                    setActionLoading(true);
                    setActionText("Sending Late Request...");

                    await axios.post(
                      `${API_URL}/attendance/request-late`,
                      {
                        type: "late_login",
                        comment: loginComment,
                        minutes: Math.round(Number(loginStatus.late_minutes ?? 0)),
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                        },
                      }
                    );

                    // 🔥 STEP-2: TURANT STATUS LO (JAISA BREAK ME KARTE HO)
                    const { data } = await axios.get(
                      `${API_URL}/attendance/status`,
                      {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                        },
                      }
                    );

                    // 🔥 STEP-3: BACKEND TRUTH APPLY
                    setLoginStatus(data);

                    // 🔥 ROUTE VISIBILITY (SESSION AWARE)
                    if (data?.permissions) {
                      localStorage.setItem(
                        "route_visibility",
                        JSON.stringify(data.permissions)
                      );
                    }

                    setLoginModalOpen(Boolean(data?.show_popup));

                  } finally {
                    setActionLoading(false);
                    setActionText("");
                  }
                }}
              >
                {actionLoading ? actionText : "Request Late Approval"}
              </Button>

            </>
          )}

        </SoftBox>
      </Modal>

      {/* Attendance Gap Modal */}
      <Modal open={gapModalOpen} onClose={() => { }}>
        <SoftBox
          style={{
            background: "white",
            padding: 30,
            maxWidth: 500,
            margin: "10% auto",
            borderRadius: 10,
            textAlign: "center",
          }}
        >
          <SoftTypography variant="h6" mb={2} color="error">
            Missing Attendance Days
          </SoftTypography>

          {gapMessage ? (
            <SoftTypography variant="body2" mb={2}>
              {gapMessage}
            </SoftTypography>
          ) : (
            <SoftTypography variant="body2" mb={2}>
              It looks like you have missing attendance for previous working days. Please tell us where you were.
            </SoftTypography>
          )}

          {gapMissingDays !== null && (
            <SoftTypography variant="caption" mb={2} style={{ display: 'block', marginBottom: 12 }}>
              Missing Days: {gapMissingDays}
            </SoftTypography>
          )}

          <TextField
            fullWidth
            multiline
            rows={4}
            label="Reason"
            value={gapReason}
            onChange={(e) => {
              setGapReason(e.target.value);
              if (gapError) setGapError("");
            }}
            error={Boolean(gapError)}
            helperText={gapError}
            sx={{ mb: 2 }}
          />

          <Button
            variant="contained"
            color="primary"
            onClick={async () => {
              if ((gapReason || "").trim() === "") {
                setGapError("Please Submit a Reason....without Reason you can not proceed further");
                return;
              }
              try {
                setActionLoading(true);
                setActionText("Sending...");

                const token = localStorage.getItem("authToken");

                await axios.post(
                  `${API_URL}/attendance-gap-reason`,
                  { reason: gapReason },
                  { headers: { Authorization: `Bearer ${token}` } }
                );

                // close modal and refresh status so Mark Attendance popup reappears
                setGapModalOpen(false);
                setGapReason("");

                // force refresh login status
                const { data } = await axios.get(
                  `${API_URL}/attendance/status`,
                  { headers: { Authorization: `Bearer ${token}` } }
                );
                setLoginStatus(data);

              } catch (e) {
                console.error('Gap reason submit failed', e);
              } finally {
                setActionLoading(false);
                setActionText("");
              }
            }}
          >
            {actionLoading ? actionText : "Submit Reason"}
          </Button>
        </SoftBox>
      </Modal>


      <Modal open={locationBlocked && !isExternalVendorContact} onClose={() => { }}>
        <SoftBox
          style={{
            background: "white",
            padding: 30,
            maxWidth: 420,
            margin: "10% auto",
            borderRadius: 10,
            textAlign: "center",
          }}
        >
          <SoftTypography variant="h6" mb={2} color="error">
            Location Permission Required
          </SoftTypography>

          <SoftTypography variant="body2" mb={2}>
            Location permission is mandatory to mark attendance.
            Please click on the 🔒 icon in your browser’s address bar and set Location to “Allow”.
          </SoftTypography>

          <Button
            variant="contained"
            color="primary"
            disabled={checkingLocation}
            onClick={async () => {
              try {
                setCheckingLocation(true);
                await getLocation();      // retry
                setLocationBlocked(false); // ✅ allowed → modal close
              } catch (e) {
                setLocationBlocked(true);  // ❌ still blocked → keep open
              } finally {
                setCheckingLocation(false);
              }
            }}
          >
            {checkingLocation ? "Checking..." : "I have enabled location"}
          </Button>
        </SoftBox>
      </Modal>


      <BreakModal
        open={loginStatus?.onBreak === true}
        timer={timer}
        onEndBreak={handleEndBreak}
      />

      {/* {isLoggedIn && (
        <IdleTracker onBreak={onBreak} />
      )} */}

      {isLoggedIn && (
        <>
          {/* <IdleTracker onBreak={onBreak} session={loginStatus?.session} loginStatus={loginStatus?.status} /> */}
          <ActivityTracker
            session={loginStatus?.session}
            loginStatus={loginStatus?.status}
            onCountsChange={setActivityCounts}
          />
        </>
      )}




    </AppBar>
  );
}


DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
